<div class="PageContent">

  <div class="overlay" *ngIf="ShowAddNewPartnerForm || ShowGeneratePartnersSearchResultsPopUp || ShowShipmentRequestPopup || ShowMassEmailPopup || ShowMassEmailResultsPopup || MassEmailShowProgressPopup || ShowPublicLinkPopup || ShowB2BRegistrationLinkPopup || ShowB2BAgentSelectContainer || ShowB2BAgentDeallocation || ShowB2BGrantURLsAccess;"></div>

  <!-- Public Link Popup -->
  <div class="ModernPopupOverlay" *ngIf="ShowPublicLinkPopup">
    <div class="ModernPopup small animated fadeInDown" style="max-width: 500px;">
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons">link</i>
          {{ 'GeneratePublicLink' | translate }}
        </div>
        <button class="ModernPopupClose" (click)="ClosePublicLinkPopup();">
          <i class="material-icons">close</i>
        </button>
      </div>

      <div class="ModernPopupBody" style="padding: 24px;">
        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'PublicLink' | translate }}</label>
          <input type="text" class="ModernFormInput" [value]="PublicLinkUrl" readonly disabled style="background: #f5f5f7; color: #1d1d1f; font-family: monospace; font-size: 13px;">
        </div>
      </div>

      <div class="ModernPopupFooter" style="padding: 16px 24px; border-top: 1px solid #e8e8ed; display: flex; justify-content: flex-end;">
        <button class="GridCommandButton GridCommandButtonBlue" (click)="CopyPublicLinkToClipboard();">
          <i class="material-icons">content_copy</i>
          <span>{{ 'CopyToClipboard' | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- B2B Registration Link Popup -->
  <div class="ModernPopupOverlay" *ngIf="ShowB2BRegistrationLinkPopup">
    <div class="ModernPopup small animated fadeInDown" style="max-width: 500px;">
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons">person_add</i>
          {{ 'B2BRegistrationLink' | translate }}
        </div>
        <button class="ModernPopupClose" (click)="CloseB2BRegistrationLinkPopup();">
          <i class="material-icons">close</i>
        </button>
      </div>

      <div class="ModernPopupBody" style="padding: 24px;">
        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'B2BRegistrationLink' | translate }}</label>
          <input type="text" class="ModernFormInput" [value]="B2BRegistrationLinkUrl" readonly disabled style="background: #f5f5f7; color: #1d1d1f; font-family: monospace; font-size: 12px; word-break: break-all;">
        </div>
      </div>

      <div class="ModernPopupFooter" style="padding: 16px 24px; border-top: 1px solid #e8e8ed; display: flex; justify-content: flex-end;">
        <button class="GridCommandButton GridCommandButtonBlue" (click)="CopyB2BRegistrationLinkToClipboard();">
          <i class="material-icons">content_copy</i>
          <span>{{ 'CopyToClipboard' | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- B2B Agent Selection Popup -->
  <div class="ModernPopupOverlay" *ngIf="ShowB2BAgentSelectContainer" style="z-index: 10000;">
    <div class="ModernPopup animated fadeInDown" style="max-width: 550px; width: 90%; max-height: 80vh; display: flex; flex-direction: column;">
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons">account_circle</i>
          {{ 'B2BConnectedAgent' | translate }}
        </div>
        <button class="ModernPopupClose" (click)="ShowB2BAgentSelectContainer = false;">
          <i class="material-icons">close</i>
        </button>
      </div>

      <div class="ModernPopupBody" style="padding: 24px; flex: 1; overflow: visible;">
        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'ChooseAgent' | translate }}</label>
          <div style="width: 100; max-height: 50vh; overflow-y: auto; border: 1px solid #e8e8ed; border-radius: 8px;">
            <div *ngFor="let agent of Agents"
                 [class.selected]="B2BConnectedAgent?.ID === agent.ID"
                 (click)="SelectB2BAgent(agent);"
                 style="padding: 12px 16px; cursor: pointer; display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #f0f0f0; transition: background 0.15s;"
                 [style.background]="B2BConnectedAgent?.ID === agent.ID ? '#e8f4fd' : '#fff'"
                 onmouseover="this.style.background=this.style.background==='rgb(232, 244, 253)' ? '#e8f4fd' : '#f8f9fa'"
                 onmouseout="this.style.background=this.getAttribute('data-sel')==='true' ? '#e8f4fd' : '#fff'"
                 [attr.data-sel]="B2BConnectedAgent?.ID === agent.ID">
              <span>{{agent.Name}}</span>
              <i class="material-icons" *ngIf="B2BConnectedAgent?.ID === agent.ID" style="color: #28a745; font-size: 20px;">check_circle</i>
            </div>
          </div>
        </div>
      </div>

      <div class="ModernPopupFooter" style="padding: 16px 24px; border-top: 1px solid #e8e8ed; display: flex; justify-content: flex-end; gap: 12px;">
        <button class="ModernActionButton" (click)="ShowB2BAgentSelectContainer = false;">
          {{ 'CancelButton' | translate }}
        </button>
        <button class="ModernActionButton primary" [disabled]="!B2BConnectedAgent?.ID" (click)="AddUpdateB2BUserAgentConnection();">
          <i class="material-icons">check</i>
          {{ 'ChooseAgent' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- B2B Agent Deallocation Confirmation Popup -->
  <div class="ModernPopupOverlay" *ngIf="ShowB2BAgentDeallocation" style="z-index: 10000;">
    <div class="ModernPopup small animated fadeInDown" style="max-width: 400px;">
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons" style="color: #dc3545;">warning</i>
          {{ 'Configuration.DeleteQuestion' | translate }}
        </div>
        <button class="ModernPopupClose" (click)="ShowB2BAgentDeallocation = false;">
          <i class="material-icons">close</i>
        </button>
      </div>

      <div class="ModernPopupBody" style="padding: 24px;">
        <p style="margin: 0; color: #666;">{{ 'B2BAgentDeallocationDescription' | translate }}</p>
      </div>

      <div class="ModernPopupFooter" style="padding: 16px 24px; border-top: 1px solid #e8e8ed; display: flex; justify-content: flex-end; gap: 12px;">
        <button class="ModernActionButton" (click)="ShowB2BAgentDeallocation = false;">
          {{ 'Configuration.DeleteNoButton' | translate }}
        </button>
        <button class="ModernActionButton danger" (click)="DeallocateB2BUserAgentConnection();">
          <i class="material-icons">delete</i>
          {{ 'Configuration.DeleteYesButton' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- B2B Grant/Revoke URLs Access Confirmation Popup -->
  <div class="ModernPopupOverlay" *ngIf="ShowB2BGrantURLsAccess" style="z-index: 10000;">
    <div class="ModernPopup small animated fadeInDown" style="max-width: 450px;">
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons" [style.color]="B2BAppAccess?.Access === true ? '#28a745' : '#dc3545'">vpn_key</i>
          <span *ngIf="B2BAppAccess?.Access === true">{{ 'GrantAllURLsAccess' | translate }}</span>
          <span *ngIf="B2BAppAccess?.Access !== true">{{ 'UnGrantAllURLsAccess' | translate }}</span>
        </div>
        <button class="ModernPopupClose" (click)="CancelB2BGrantURLsAccess();">
          <i class="material-icons">close</i>
        </button>
      </div>

      <div class="ModernPopupBody" style="padding: 24px;">
        <p *ngIf="B2BAppAccess?.Access === true" style="margin: 0; color: #666;">{{ 'GrantAllURLsAccessDescription' | translate }}</p>
        <p *ngIf="B2BAppAccess?.Access !== true" style="margin: 0; color: #666;">{{ 'UnGrantAllURLsAccessDescription' | translate }}</p>
      </div>

      <div class="ModernPopupFooter" style="padding: 16px 24px; border-top: 1px solid #e8e8ed; display: flex; justify-content: flex-end; gap: 12px;">
        <button class="ModernActionButton" (click)="CancelB2BGrantURLsAccess();">
          {{ 'CancelButton' | translate }}
        </button>
        <button *ngIf="B2BAppAccess?.Access === true" class="ModernActionButton success" (click)="GrantB2BUserAppUrlsAccess();">
          <i class="material-icons">check</i>
          {{ 'GrantAllURLsAccessButton' | translate }}
        </button>
        <button *ngIf="B2BAppAccess?.Access !== true" class="ModernActionButton" style="background: #dc3545; color: white;" (click)="GrantB2BUserAppUrlsAccess();">
          <i class="material-icons">block</i>
          {{ 'UnGrantAllURLsAccessButton' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modern Shipment Request Popup -->
  <div class="ModernPopupOverlay" *ngIf="this.ShowShipmentRequestPopup == true;">
    <div class="ModernPopup large animated fadeInDown">
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons">local_shipping</i>
          {{'SendShipmentRequestPreparation' | translate}}
        </div>
        <button class="ModernPopupClose" (click)="this.ShowShipmentRequestPopup = false;">
          <i class="material-icons">close</i>
        </button>
      </div>

      <div class="ModernPopupBody">
        <!-- Shipping Options -->
        <div class="ModernFormRow" *ngIf="this.parent.loading != true;">
          <div class="ModernFormGroup third">
            <label class="ModernFormLabel">{{ 'ShippingResponsability' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showShippingResponsabilityDropdown" (click)="showShippingResponsabilityDropdown = false;"></div>
              <div class="ModernDropdownBar" [class.open]="showShippingResponsabilityDropdown" [class.disabled]="this.parent.loading" (click)="!this.parent.loading && (showShippingResponsabilityDropdown = !showShippingResponsabilityDropdown)">
                <span class="ModernDropdownText" [class.placeholder]="!this.ShippingDetails?.ShippingResponsability">
                  {{ this.ShippingDetails?.ShippingResponsability ? this.ShippingDetails.ShippingResponsability.Name + ' (' + this.ShippingDetails.ShippingResponsability.Description + ')' : ('Select' | translate) }}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showShippingResponsabilityDropdown">
                <div class="ModernDropdownOption" *ngFor="let s of this.ShippingResponsabilities;"
                     [class.selected]="this.ShippingDetails?.ShippingResponsability?.ID === s.ID"
                     (click)="this.ShippingDetails.ShippingResponsability = s; showShippingResponsabilityDropdown = false;">
                  {{s.Name}} ({{s.Description}})
                  <i class="material-icons check-icon" *ngIf="this.ShippingDetails?.ShippingResponsability?.ID === s.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup third">
            <label class="ModernFormLabel">{{ 'ShippingCompany' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showShippingCompanyDropdown" (click)="showShippingCompanyDropdown = false;"></div>
              <div class="ModernDropdownBar" [class.open]="showShippingCompanyDropdown" [class.disabled]="this.parent.loading || this.ShippingDetails?.ShippingResponsability?.ID !== 1" (click)="!(this.parent.loading || this.ShippingDetails?.ShippingResponsability?.ID !== 1) && (showShippingCompanyDropdown = !showShippingCompanyDropdown)">
                <span class="ModernDropdownText" [class.placeholder]="!this.ShippingDetails?.ShippingCompany">
                  {{ this.ShippingDetails?.ShippingCompany?.Name || ('Select' | translate) }}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showShippingCompanyDropdown">
                <div class="ModernDropdownOption" *ngFor="let s of this.ShippingCompanies;"
                     [class.selected]="this.ShippingDetails?.ShippingCompany?.ID === s.ID"
                     (click)="this.ShippingDetails.ShippingCompany = s; showShippingCompanyDropdown = false;">
                  {{s.Name}}
                  <i class="material-icons check-icon" *ngIf="this.ShippingDetails?.ShippingCompany?.ID === s.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup third">
            <label class="ModernFormLabel">{{ 'ShippingServiceType' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showShippingServiceDropdown" (click)="showShippingServiceDropdown = false;"></div>
              <div class="ModernDropdownBar" [class.open]="showShippingServiceDropdown" [class.disabled]="this.parent.loading || this.ShippingDetails?.ShippingResponsability?.ID !== 1" (click)="!(this.parent.loading || this.ShippingDetails?.ShippingResponsability?.ID !== 1) && (showShippingServiceDropdown = !showShippingServiceDropdown)">
                <span class="ModernDropdownText" [class.placeholder]="!this.ShippingDetails?.ShippingServiceType">
                  {{ this.ShippingDetails?.ShippingServiceType?.Name || ('Select' | translate) }}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showShippingServiceDropdown">
                <div class="ModernDropdownOption" *ngFor="let s of this.ShippingServiceTypes;"
                     [class.selected]="this.ShippingDetails?.ShippingServiceType?.ID === s.ID"
                     (click)="this.ShippingDetails.ShippingServiceType = s; showShippingServiceDropdown = false;">
                  {{s.Name}}
                  <i class="material-icons check-icon" *ngIf="this.ShippingDetails?.ShippingServiceType?.ID === s.ID">check</i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ModernSectionDivider"></div>

        <!-- Email Recipients -->
        <div class="ModernSectionTitle">{{'CCEmailCopy' | translate}}</div>
        <div class="ActiveFiltersContainer" style="margin-bottom: 16px;">
          <div class="ActiveFilterChip" *ngFor="let a of this.PartnerAgents;"
               (click)="a.IsSelected = !a.IsSelected;"
               [style.background]="a.IsSelected ? '#e8f5e9' : '#ffebee'"
               [style.color]="a.IsSelected ? '#388e3c' : '#d32f2f'">
            <i class="material-icons" style="font-size: 14px;">{{a.IsSelected ? 'check' : 'close'}}</i>
            {{a.Email}}
          </div>
        </div>

        <!-- Message -->
        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'YouMessageForOurTeam' | translate }}</label>
          <textarea class="ModernFormTextarea"
                    autocomplete="off"
                    rows="4"
                    [(ngModel)]="ClientMessage"
                    placeholder="{{ 'YouMessageForOurTeam' | translate }}"></textarea>
        </div>

        <!-- Info Banner -->
        <div style="display: flex; align-items: center; gap: 10px; padding: 12px 16px; background: #e3f2fd; border-radius: 40px; margin-top: 16px; border: 1px solid #bbdefb;">
          <i class="material-icons" style="color: #1976d2; font-size: 18px;">info_outline</i>
          <span style="font-size: 12px; color: #1565c0;">
            <span *ngIf="this.ShippingDetails?.ShippingResponsability?.ID == 0">{{'ShipmentEXW' | translate}}</span>
            <span *ngIf="this.ShippingDetails?.ShippingResponsability?.ID == 1">
              {{'ShipmentDAP' | translate}} ({{this.ShippingDetails?.ShippingServiceType?.Name}}) -
              {{'ShippingCompany' | translate}}: {{this.ShippingDetails?.ShippingCompany?.Name}}
            </span>
          </span>
        </div>
      </div>

      <div class="ModernPopupFooter">
        <button class="ModernButton outline" (click)="this.ShowShipmentRequestPopup = false;">
          {{ 'Cancel' | translate }}
        </button>
        <button class="ModernButton success"
                (click)="SendDispatchEmailClientRequest();"
                [disabled]="this.parent.loading || !this.ShippingDetails.ShippingServiceType">
          <i class="material-icons">send</i>
          {{'SendRequest' | translate}}
        </button>
      </div>
    </div>
  </div>

  <!-- Modern MASS Email Popup -->
  <div class="ModernPopupOverlay" *ngIf="ShowMassEmailPopup == true;">
    <div class="ModernPopup xlarge animated fadeInDown" style="height: 90vh;">
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons">email</i>
          {{ 'MassEmail' | translate }}
        </div>
        <button class="ModernPopupClose" (click)="CloseMassEmailPopup();">
          <i class="material-icons">close</i>
        </button>
      </div>

      <!-- Tabs -->
      <div class="MassEmailTabs">
        <button class="MassEmailTab" [class.active]="MassEmailActiveTab === 'compose'" (click)="SwitchMassEmailTab('compose')">
          <i class="material-icons">edit</i>
          {{ 'NewMessage' | translate }}
        </button>
        <button class="MassEmailTab" [class.active]="MassEmailActiveTab === 'history'" (click)="SwitchMassEmailTab('history')">
          <i class="material-icons">history</i>
          {{ 'History' | translate }}
        </button>
      </div>

      <!-- Compose Tab Content -->
      <div class="ModernPopupBody" *ngIf="MassEmailActiveTab === 'compose'" style="display: flex; flex-direction: row; gap: 20px; overflow: hidden;">
        <!-- Left Panel - Partner/Agent Selection -->
        <div class="MassEmailLeftPanel" style="flex: 1; display: flex; flex-direction: column; overflow: hidden; border-right: 1px solid #e9ecef; padding-right: 20px;">
          <div class="MassEmailSelectionHeader" style="margin-bottom: 12px;">
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px;">
              <h4 style="margin: 0; font-size: 14px; font-weight: 600; color: #333;">{{ 'SelectRecipients' | translate }}</h4>
              <span style="font-size: 12px; color: #666;">{{ SelectedAgentsCount }} {{ 'Selected' | translate }}</span>
            </div>

            <!-- Search Box -->
            <div class="ModernFormGroup" style="margin-bottom: 10px;">
              <div style="position: relative;">
                <i class="material-icons" style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); font-size: 18px; color: #888;">search</i>
                <input type="text"
                       class="ModernFormInput"
                       style="padding-left: 36px; padding-right: 32px;"
                       [(ngModel)]="MassEmailSearchQuery"
                       (ngModelChange)="OnMassEmailSearchChange()"
                       placeholder="{{ 'SearchPartnersOrEmails' | translate }}">
                <i class="material-icons"
                   *ngIf="MassEmailSearchQuery"
                   (click)="ClearMassEmailSearch()"
                   style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); font-size: 18px; color: #888; cursor: pointer;">close</i>
              </div>
            </div>

            <!-- Filter Status Indicator -->
            <div *ngIf="MassEmailIsFiltered" style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 6px; padding: 6px 10px; background: #e3f2fd; border-radius: 6px; font-size: 11px;">
              <span style="color: #1976d2;">
                <i class="material-icons" style="font-size: 14px; vertical-align: middle; margin-right: 4px;">filter_list</i>
                {{ 'ShowingXOfYPartners' | translate:{ visible: MassEmailVisiblePartnersCount, total: MassEmailTotalPartnersCount } }}
              </span>
              <span style="color: #1976d2; cursor: pointer; text-decoration: underline;" (click)="ClearMassEmailSearch(); MassEmailDepartmentFilter = []; ApplyMassEmailFilters();">
                {{ 'ClearFilters' | translate }}
              </span>
            </div>

            <!-- Selection Count Indicator -->
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; padding: 6px 10px; background: #f5f5f5; border-radius: 6px; font-size: 11px;">
              <span style="color: #555;">
                <i class="material-icons" style="font-size: 14px; vertical-align: middle; margin-right: 4px;">check_circle</i>
                {{ 'SelectedXOfYAgents' | translate:{ selected: SelectedAgentsCount, total: TotalAgentsCount } }}
              </span>
            </div>

            <!-- Department Filter -->
            <div class="ModernFormGroup" *ngIf="Departments?.length > 0" style="margin-bottom: 10px;">
              <label class="ModernFormLabel" style="font-size: 12px;">{{ 'FilterByDepartment' | translate }}</label>
              <div class="ModernDropdownContainer">
                <div class="ModernDropdownOverlay" *ngIf="showMassEmailDepartmentDropdown" (click)="showMassEmailDepartmentDropdown = false"></div>
                <div class="ModernDropdownBar" [class.open]="showMassEmailDepartmentDropdown" (click)="showMassEmailDepartmentDropdown = !showMassEmailDepartmentDropdown">
                  <span class="ModernDropdownText" [class.placeholder]="MassEmailDepartmentFilter.length === 0">
                    {{ MassEmailDepartmentFilter.length > 0 ? MassEmailDepartmentFilter.length + ' ' + ('DepartmentsSelected' | translate) : ('AllDepartments' | translate) }}
                  </span>
                  <i class="material-icons ModernDropdownArrow">expand_more</i>
                </div>
                <div class="ModernDropdownResults" *ngIf="showMassEmailDepartmentDropdown" style="max-height: 200px;">
                  <!-- Select All Departments Option -->
                  <div class="ModernDropdownOption"
                       [class.selected]="AreAllDepartmentsSelected()"
                       (click)="ToggleAllDepartments(); $event.stopPropagation();"
                       style="border-bottom: 1px solid #e0e0e0; font-weight: 500;">
                    <i class="material-icons" style="font-size: 16px; margin-right: 6px;">
                      {{ AreAllDepartmentsSelected() ? 'check_box' : 'check_box_outline_blank' }}
                    </i>
                    {{ 'SelectAllDepartments' | translate }}
                  </div>
                  <!-- Individual Department Options -->
                  <div class="ModernDropdownOption" *ngFor="let d of Departments"
                       [class.selected]="IsDepartmentSelected(d)"
                       (click)="ToggleMassEmailDepartment(d); $event.stopPropagation();">
                    <i class="material-icons" style="font-size: 16px; margin-right: 6px;">
                      {{ IsDepartmentSelected(d) ? 'check_box' : 'check_box_outline_blank' }}
                    </i>
                    {{ d.Name }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Select All / Deselect All Buttons -->
            <div style="display: flex; gap: 8px;">
              <button class="GridCommandButton" style="font-size: 11px; padding: 4px 10px; height: auto;" (click)="SelectAllMassEmailAgents();">
                <i class="material-icons" style="font-size: 14px;">check_box</i>
                {{ 'SelectAll' | translate }}
              </button>
              <button class="GridCommandButton" style="font-size: 11px; padding: 4px 10px; height: auto;" (click)="DeselectAllMassEmailAgents();">
                <i class="material-icons" style="font-size: 14px;">check_box_outline_blank</i>
                {{ 'DeselectAll' | translate }}
              </button>
            </div>
          </div>

          <!-- Partner/Agent List -->
          <div class="MassEmailAgentsList" style="flex: 1; overflow-y: auto; border: 1px solid #e9ecef; border-radius: 8px;">
            <div *ngFor="let group of GroupedPartners"
                 [hidden]="group.IsGroupHidden"
                 class="MassEmailPartnerGroup">
              <!-- Partner Header -->
              <div class="MassEmailPartnerHeader" style="display: flex; align-items: center; padding: 10px 12px; background: #f8f9fa; border-bottom: 1px solid #e9ecef; cursor: pointer;"
                   (click)="TogglePartnerExpanded(group);">
                <i class="material-icons" style="font-size: 18px; color: #666; margin-right: 8px;">
                  {{ group.IsExpanded ? 'expand_more' : 'chevron_right' }}
                </i>
                <div class="MassEmailCheckbox" (click)="ToggleAllPartnerAgents(group); $event.stopPropagation();" style="margin-right: 10px;">
                  <i class="material-icons" style="font-size: 18px; color: #4a7bb8;">
                    {{ group.AllSelected ? 'check_box' : (group.SomeSelected ? 'indeterminate_check_box' : 'check_box_outline_blank') }}
                  </i>
                </div>
                <span style="font-weight: 600; font-size: 13px; color: #333;">{{ group.Partner?.Name }}</span>
                <span style="margin-left: 8px; font-size: 11px; color: #888;">({{ group.VisibleAgentsCount || group.Agents.length }} {{ 'Agents' | translate }})</span>
              </div>

              <!-- Agent List -->
              <div class="MassEmailAgentsList" *ngIf="group.IsExpanded" style="padding: 4px 0;">
                <div *ngFor="let agent of group.Agents"
                     [hidden]="agent.IsHidden"
                     class="MassEmailAgentRow"
                     style="display: flex; align-items: center; padding: 8px 12px 8px 44px; border-bottom: 1px solid #f0f0f0; cursor: pointer;"
                     (click)="ToggleAgentSelection(agent);">
                  <i class="material-icons" style="font-size: 18px; color: #4a7bb8; margin-right: 10px;">
                    {{ agent.IsSelected ? 'check_box' : 'check_box_outline_blank' }}
                  </i>
                  <div style="flex: 1;">
                    <div style="font-size: 13px; color: #333;">{{ agent.FirstName }} {{ agent.LastName }}</div>
                    <div style="font-size: 11px; color: #888;">{{ agent.Email }}</div>
                  </div>
                  <div style="font-size: 11px; color: #666; background: #f0f4f8; padding: 2px 8px; border-radius: 10px;">
                    {{ agent.Department?.Name || '-' }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty State - No Partners at all -->
            <div *ngIf="GroupedPartners.length === 0 && !this.parent.loading" style="padding: 40px; text-align: center; color: #888;">
              <i class="material-icons" style="font-size: 48px; opacity: 0.5;">people_outline</i>
              <div style="margin-top: 12px;">{{ 'NoPartnersFound' | translate }}</div>
            </div>

            <!-- Empty State - No results after filtering -->
            <div *ngIf="GroupedPartners.length > 0 && MassEmailVisiblePartnersCount === 0 && MassEmailIsFiltered" style="padding: 40px; text-align: center; color: #888;">
              <i class="material-icons" style="font-size: 48px; opacity: 0.5;">search_off</i>
              <div style="margin-top: 12px;">{{ 'NoResultsFound' | translate }}</div>
              <div style="margin-top: 8px; font-size: 12px;">{{ 'TryAdjustingFilters' | translate }}</div>
            </div>
          </div>
        </div>

        <!-- Right Panel - Email Composition -->
        <div class="MassEmailRightPanel" style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">
          <!-- SMTP Configuration -->
          <div class="MassEmailSMTPConfig" style="margin-bottom: 16px;">
            <div class="ModernFormRow" style="display: flex; gap: 12px;">
              <!-- SMTP Server Dropdown -->
              <div class="ModernFormGroup" style="flex: 1;">
                <label class="ModernFormLabel" style="font-size: 12px;">{{ 'SMTPServer' | translate }}</label>
                <div class="ModernDropdownContainer">
                  <div class="ModernDropdownOverlay" *ngIf="showMassEmailSMTPDropdown" (click)="showMassEmailSMTPDropdown = false"></div>
                  <div class="ModernDropdownBar" [class.open]="showMassEmailSMTPDropdown" (click)="showMassEmailSMTPDropdown = !showMassEmailSMTPDropdown">
                    <span class="ModernDropdownText" [class.placeholder]="!MassEmailCurrentSMTP">
                      {{ MassEmailCurrentSMTP ? MassEmailCurrentSMTP.SMTPServer + ' (' + MassEmailCurrentSMTP.Port + ')' : ('SelectSMTP' | translate) }}
                    </span>
                    <i class="material-icons ModernDropdownArrow">expand_more</i>
                  </div>
                  <div class="ModernDropdownResults" *ngIf="showMassEmailSMTPDropdown">
                    <div class="ModernDropdownOption" *ngFor="let smtp of MassEmailSMTPConfigs"
                         [class.selected]="MassEmailCurrentSMTP?.ID === smtp.ID"
                         (click)="SelectMassEmailSMTP(smtp);">
                      {{ smtp.SMTPServer }} ({{ smtp.Port }})
                    </div>
                  </div>
                </div>
              </div>

              <!-- From Email Dropdown -->
              <div class="ModernFormGroup" style="flex: 1;">
                <label class="ModernFormLabel" style="font-size: 12px;">{{ 'FromEmail' | translate }}</label>
                <div class="ModernDropdownContainer">
                  <div class="ModernDropdownOverlay" *ngIf="showMassEmailSMTPEmailDropdown" (click)="showMassEmailSMTPEmailDropdown = false"></div>
                  <div class="ModernDropdownBar" [class.open]="showMassEmailSMTPEmailDropdown" (click)="showMassEmailSMTPEmailDropdown = !showMassEmailSMTPEmailDropdown">
                    <span class="ModernDropdownText" [class.placeholder]="!MassEmailCurrentSMTPEmail">
                      {{ MassEmailCurrentSMTPEmail?.Email || ('SelectEmail' | translate) }}
                    </span>
                    <i class="material-icons ModernDropdownArrow">expand_more</i>
                  </div>
                  <div class="ModernDropdownResults" *ngIf="showMassEmailSMTPEmailDropdown">
                    <div class="ModernDropdownOption" *ngFor="let email of MassEmailSMTPEmails"
                         [class.selected]="MassEmailCurrentSMTPEmail?.ID === email.ID"
                         (click)="SelectMassEmailSMTPEmail(email);">
                      {{ email.Email }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Subject -->
          <div class="ModernFormGroup" style="margin-bottom: 12px;">
            <label class="ModernFormLabel" style="font-size: 12px;">{{ 'Subject' | translate }} *</label>
            <input type="text" class="ModernFormInput" [(ngModel)]="MassEmailSubject" placeholder="{{ 'EnterEmailSubject' | translate }}">
          </div>

          <!-- Body -->
          <div class="ModernFormGroup" style="flex: 1; display: flex; flex-direction: column; margin-bottom: 12px;">
            <label class="ModernFormLabel" style="font-size: 12px;">{{ 'Message' | translate }} *</label>
            <textarea class="ModernFormTextarea" [(ngModel)]="MassEmailBody" placeholder="{{ 'EnterEmailMessage' | translate }}"
                      style="flex: 1; min-height: 150px; resize: none;"></textarea>
          </div>

          <!-- Use Signature Checkbox -->
          <div class="MassEmailSignatureToggle" style="margin-bottom: 12px; display: flex; align-items: center; gap: 8px;">
            <div class="ModernCheckbox" (click)="MassEmailUseSignature = !MassEmailUseSignature" style="cursor: pointer;">
              <i class="material-icons" style="font-size: 20px; color: #4a7bb8;">
                {{ MassEmailUseSignature ? 'check_box' : 'check_box_outline_blank' }}
              </i>
            </div>
            <label style="font-size: 13px; color: #333; cursor: pointer;" (click)="MassEmailUseSignature = !MassEmailUseSignature">
              {{ 'UseEmailSignature' | translate }}
            </label>
          </div>

          <!-- Attachments -->
          <div class="MassEmailAttachments" style="margin-bottom: 12px;">
            <label class="ModernFormLabel" style="font-size: 12px;">{{ 'Attachments' | translate }}</label>
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">
              <input type="file" #massEmailFileInput style="display: none;" multiple (change)="OnMassEmailFileSelected($event)">
              <button class="GridCommandButton" style="font-size: 12px; padding: 6px 12px;" (click)="massEmailFileInput.click();">
                <i class="material-icons" style="font-size: 16px;">attach_file</i>
                {{ 'AddAttachment' | translate }}
              </button>
              <span style="font-size: 11px; color: #888;">{{ 'MaxFileSize' | translate }}: 20MB</span>
            </div>
            <div class="MassEmailAttachmentsList" *ngIf="MassEmailAttachments.length > 0" style="display: flex; flex-wrap: wrap; gap: 8px;">
              <div *ngFor="let att of MassEmailAttachments; let i = index"
                   class="MassEmailAttachmentChip"
                   style="display: flex; align-items: center; gap: 6px; background: #f0f4f8; padding: 6px 10px; border-radius: 16px; font-size: 12px;">
                <i class="material-icons" style="font-size: 16px; color: #666;">insert_drive_file</i>
                <span>{{ att.FileName }}</span>
                <span style="color: #888;">({{ FormatFileSize(att.FileSize) }})</span>
                <i class="material-icons" style="font-size: 16px; color: #dc3545; cursor: pointer;" (click)="RemoveMassEmailAttachment(i);">close</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- History Tab Content -->
      <div class="ModernPopupBody" *ngIf="MassEmailActiveTab === 'history'" style="display: flex; flex-direction: column; overflow: hidden;">
        <!-- History Filters -->
        <div class="MassEmailHistoryFilters" style="display: flex; gap: 15px; align-items: center; padding-bottom: 15px; border-bottom: 1px solid #e9ecef; margin-bottom: 15px;">
          <div class="ModernFormGroup" style="margin: 0;">
            <label class="ModernFormLabel" style="font-size: 12px; margin-bottom: 4px;">{{ 'DateFrom' | translate }}</label>
            <input matInput [matDatepicker]="historyDateFromPicker"
                   [(ngModel)]="MassEmailHistoryDateFrom"
                   class="ModernFormInput"
                   style="width: 140px; cursor: pointer;"
                   readonly
                   (click)="historyDateFromPicker.open()">
            <mat-datepicker #historyDateFromPicker></mat-datepicker>
          </div>
          <div class="ModernFormGroup" style="margin: 0;">
            <label class="ModernFormLabel" style="font-size: 12px; margin-bottom: 4px;">{{ 'DateTo' | translate }}</label>
            <input matInput [matDatepicker]="historyDateToPicker"
                   [(ngModel)]="MassEmailHistoryDateTo"
                   class="ModernFormInput"
                   style="width: 140px; cursor: pointer;"
                   readonly
                   (click)="historyDateToPicker.open()">
            <mat-datepicker #historyDateToPicker></mat-datepicker>
          </div>
          <button class="ModernButton primary" style="margin-top: 18px;" (click)="GetMassEmailHistory()">
            <i class="material-icons">search</i>
            {{ 'Search' | translate }}
          </button>
          <button class="ModernButton outline" style="margin-top: 18px;" (click)="MassEmailHistoryDateFrom = null; MassEmailHistoryDateTo = null; GetMassEmailHistory()">
            <i class="material-icons">clear</i>
            {{ 'ClearFilters' | translate }}
          </button>
        </div>

        <!-- History List -->
        <div class="MassEmailHistoryList" style="flex: 1; overflow-y: auto;">
          <div *ngIf="MassEmailHistoryLoading" style="display: flex; justify-content: center; align-items: center; padding: 40px;">
            <mat-spinner [diameter]="32"></mat-spinner>
          </div>

          <div *ngIf="!MassEmailHistoryLoading && MassEmailHistory.length === 0" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 60px; color: #999;">
            <i class="material-icons" style="font-size: 48px; margin-bottom: 10px;">inbox</i>
            <span>{{ 'NoMassEmailsFound' | translate }}</span>
          </div>

          <!-- History Items -->
          <div class="MassEmailHistoryItem" *ngFor="let message of MassEmailHistory" style="margin-bottom: 10px; border: 1px solid #e9ecef; border-radius: 8px; overflow: hidden;">
            <!-- Header Row (Always Visible) -->
            <div class="MassEmailHistoryItemHeader" (click)="ToggleMassMessageExpanded(message)" style="display: flex; align-items: center; padding: 12px 15px; background: #f8f9fa; cursor: pointer;">
              <i class="material-icons" style="margin-right: 10px; color: #666; transition: transform 0.2s;" [style.transform]="message.IsExpanded ? 'rotate(90deg)' : 'rotate(0deg)'">chevron_right</i>
              <div style="flex: 1; display: flex; gap: 20px; align-items: center;">
                <span style="font-weight: 600; color: #333; flex: 2;">{{ message.Subject }}</span>
                <span style="font-size: 12px; color: #666; flex: 1;">{{ message.SenderUserName }}</span>
                <span style="font-size: 12px; color: #666; width: 130px;">{{ message.EventRegisterUI }}</span>
                <span style="display: flex; gap: 8px; align-items: center;">
                  <span style="display: inline-flex; align-items: center; gap: 4px; padding: 2px 8px; background: #e8f5e9; border-radius: 12px; font-size: 11px; color: #2e7d32;">
                    <i class="material-icons" style="font-size: 14px;">check_circle</i>
                    {{ message.SuccessCount }}
                  </span>
                  <span *ngIf="message.FailedCount > 0" style="display: inline-flex; align-items: center; gap: 4px; padding: 2px 8px; background: #ffebee; border-radius: 12px; font-size: 11px; color: #c62828;">
                    <i class="material-icons" style="font-size: 14px;">error</i>
                    {{ message.FailedCount }}
                  </span>
                </span>
              </div>
            </div>

            <!-- Details (Expanded) -->
            <div *ngIf="message.IsExpanded" class="MassEmailHistoryItemDetails" style="padding: 15px; border-top: 1px solid #e9ecef;">
              <!-- Body Preview -->
              <div style="margin-bottom: 15px;">
                <label style="font-size: 11px; font-weight: 600; color: #666; text-transform: uppercase; margin-bottom: 5px; display: block;">{{ 'MessageBody' | translate }}</label>
                <div style="padding: 10px; background: #f8f9fa; border-radius: 6px; font-size: 13px; max-height: 100px; overflow-y: auto;" [innerHTML]="message.Body"></div>
              </div>

              <!-- Attachments -->
              <div *ngIf="message.Attachments?.length > 0" style="margin-bottom: 15px;">
                <label style="font-size: 11px; font-weight: 600; color: #666; text-transform: uppercase; margin-bottom: 5px; display: block;">{{ 'Attachments' | translate }} ({{ message.Attachments.length }})</label>
                <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                  <div *ngFor="let att of message.Attachments"
                       (click)="DownloadMassMessageAttachment(att)"
                       style="display: inline-flex; align-items: center; gap: 6px; padding: 4px 10px; background: #e3f2fd; border-radius: 4px; font-size: 12px; cursor: pointer; transition: background 0.2s;"
                       title="{{ 'ClickToDownload' | translate }}"
                       class="MassEmailHistoryAttachment">
                    <i class="material-icons" style="font-size: 16px; color: #1976d2;">attach_file</i>
                    <span>{{ att.FileName }}</span>
                    <span style="color: #888;">({{ att.FileSizeUI }})</span>
                    <i class="material-icons" style="font-size: 14px; color: #1976d2;">download</i>
                  </div>
                </div>
              </div>

              <!-- Recipients -->
              <div>
                <label style="font-size: 11px; font-weight: 600; color: #666; text-transform: uppercase; margin-bottom: 5px; display: block;">{{ 'Recipients' | translate }} ({{ message.Recipients?.length || 0 }})</label>
                <div style="max-height: 200px; overflow-y: auto; display: flex; flex-wrap: wrap; gap: 6px;">
                  <div *ngFor="let r of message.Recipients" style="display: inline-flex; align-items: center; gap: 6px; padding: 4px 10px; border-radius: 4px; font-size: 12px;"
                       [style.background]="r.SendSuccess ? '#e8f5e9' : '#ffebee'">
                    <i class="material-icons" style="font-size: 14px;" [style.color]="r.SendSuccess ? '#2e7d32' : '#c62828'">
                      {{ r.SendSuccess ? 'check_circle' : 'error' }}
                    </i>
                    <span style="font-weight: 500;">{{ r.AgentName }}</span>
                    <span style="color: #666;">({{ r.PartnerName }})</span>
                    <span style="color: #888;">{{ r.AgentEmail }}</span>
                    <span *ngIf="r.SendError" style="color: #c62828; font-style: italic;">- {{ r.SendError }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer (Compose Tab Only) -->
      <div class="ModernPopupFooter" *ngIf="MassEmailActiveTab === 'compose'">
        <button class="ModernButton outline" (click)="CloseMassEmailPopup();">
          {{ 'Cancel' | translate }}
        </button>
        <button class="ModernButton success"
                (click)="ShowMassEmailConfirmationPopup();"
                [disabled]="MassEmailSending || !MassEmailSubject || !MassEmailBody || SelectedAgentsCount === 0">
          <i class="material-icons" *ngIf="!MassEmailSending">send</i>
          <mat-spinner *ngIf="MassEmailSending" [diameter]="16"></mat-spinner>
          {{ MassEmailSending ? ('Sending' | translate) + '...' : ('SendEmails' | translate) }}
        </button>
      </div>

      <!-- Footer (History Tab) -->
      <div class="ModernPopupFooter" *ngIf="MassEmailActiveTab === 'history'">
        <button class="ModernButton outline" (click)="CloseMassEmailPopup();">
          {{ 'Close' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- MASS Email Confirmation Popup (2-Step Verification) -->
  <div class="ModernPopupOverlay" *ngIf="ShowMassEmailConfirmation == true;">
    <div class="ModernPopup small animated fadeInDown" style="max-width: 450px;">
      <div class="ModernPopupHeader">
        <i class="material-icons" style="color: #ff9800;">warning</i>
        <span>{{ 'ConfirmMassEmail' | translate }}</span>
        <i class="material-icons closeIcon" (click)="CancelMassEmailConfirmation();">close</i>
      </div>
      <div class="ModernPopupBody" style="text-align: center; padding: 30px 20px;">
        <!-- Warning Message -->
        <div style="margin-bottom: 25px;">
          <p style="font-size: 16px; margin-bottom: 10px;">
            {{ 'AreYouSureToSendEmailsTo' | translate }}
          </p>
          <p style="font-size: 24px; font-weight: bold; color: #1976d2;">
            {{ MassEmailConfirmationRecipientCount }} {{ 'recipients' | translate }}
          </p>
        </div>

        <!-- Confirmation Code Display -->
        <div style="margin-bottom: 20px; padding: 15px; background: #f5f5f5; border-radius: 8px;">
          <p style="font-size: 14px; color: #666; margin-bottom: 10px;">
            {{ 'EnterConfirmationCodeToConfirm' | translate }}
          </p>
          <p style="font-size: 32px; font-weight: bold; letter-spacing: 8px; color: #333; font-family: monospace;">
            {{ MassEmailConfirmationCode }}
          </p>
        </div>

        <!-- 4-Digit Input Boxes (explicit to avoid *ngFor tracking issues) -->
        <div class="confirmation-digits-container">
          <input type="text"
                 class="confirmation-digit-input"
                 id="confirm-digit-0"
                 #digit0
                 (input)="OnConfirmationDigitInput($event, 0, digit1)"
                 (keydown)="OnConfirmationDigitKeydown($event, 0, null)"
                 maxlength="1"
                 inputmode="numeric"
                 autocomplete="off"
                 [class.valid]="digit0.value && digit0.value === MassEmailConfirmationCode[0]"
                 [class.invalid]="digit0.value && digit0.value !== MassEmailConfirmationCode[0]">
          <input type="text"
                 class="confirmation-digit-input"
                 id="confirm-digit-1"
                 #digit1
                 (input)="OnConfirmationDigitInput($event, 1, digit2)"
                 (keydown)="OnConfirmationDigitKeydown($event, 1, digit0)"
                 maxlength="1"
                 inputmode="numeric"
                 autocomplete="off"
                 [class.valid]="digit1.value && digit1.value === MassEmailConfirmationCode[1]"
                 [class.invalid]="digit1.value && digit1.value !== MassEmailConfirmationCode[1]">
          <input type="text"
                 class="confirmation-digit-input"
                 id="confirm-digit-2"
                 #digit2
                 (input)="OnConfirmationDigitInput($event, 2, digit3)"
                 (keydown)="OnConfirmationDigitKeydown($event, 2, digit1)"
                 maxlength="1"
                 inputmode="numeric"
                 autocomplete="off"
                 [class.valid]="digit2.value && digit2.value === MassEmailConfirmationCode[2]"
                 [class.invalid]="digit2.value && digit2.value !== MassEmailConfirmationCode[2]">
          <input type="text"
                 class="confirmation-digit-input"
                 id="confirm-digit-3"
                 #digit3
                 (input)="OnConfirmationDigitInput($event, 3, null)"
                 (keydown)="OnConfirmationDigitKeydown($event, 3, digit2)"
                 maxlength="1"
                 inputmode="numeric"
                 autocomplete="off"
                 [class.valid]="digit3.value && digit3.value === MassEmailConfirmationCode[3]"
                 [class.invalid]="digit3.value && digit3.value !== MassEmailConfirmationCode[3]">
        </div>

        <!-- Error Message -->
        <div *ngIf="MassEmailConfirmationError" style="color: #f44336; margin-top: 15px; font-size: 14px;">
          {{ MassEmailConfirmationError }}
        </div>
      </div>
      <div class="ModernPopupFooter">
        <button class="ModernButton outline" (click)="CancelMassEmailConfirmation();">
          {{ 'Cancel' | translate }}
        </button>
        <button class="ModernButton success"
                (click)="ConfirmAndSendMassEmail();"
                [disabled]="!IsConfirmationCodeComplete()">
          <i class="material-icons">check</i>
          {{ 'ConfirmSend' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- MASS Email Progress Popup -->
  <div class="ModernPopupOverlay" *ngIf="MassEmailShowProgressPopup == true;">
    <div class="ModernPopup small animated fadeInDown" style="max-width: 500px;">
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons">send</i>
          {{ 'SendingEmails' | translate }}
        </div>
      </div>

      <div class="ModernPopupBody" style="padding: 24px;">
        <!-- Progress Info -->
        <div style="text-align: center; margin-bottom: 20px;">
          <div style="font-size: 36px; font-weight: 700; color: #2196F3;">{{ MassEmailProgressPercent }}%</div>
          <div style="font-size: 14px; color: #666; margin-top: 4px;">
            {{ MassEmailProgressCompleted }} / {{ MassEmailProgressTotal }} {{ 'EmailsSent' | translate }}
          </div>
        </div>

        <!-- Progress Bar -->
        <div style="background: #e0e0e0; border-radius: 10px; height: 16px; overflow: hidden; margin-bottom: 20px;">
          <div style="height: 100%; border-radius: 10px; transition: width 0.3s ease;"
               [style.width.%]="MassEmailProgressPercent"
               [style.background]="MassEmailProgressPercent < 100 ? 'linear-gradient(90deg, #2196F3, #64B5F6)' : 'linear-gradient(90deg, #4CAF50, #81C784)'">
          </div>
        </div>

        <!-- Success/Error Counts -->
        <div style="display: flex; gap: 20px; justify-content: center;">
          <div style="text-align: center; padding: 12px 20px; background: #e8f5e9; border-radius: 8px;">
            <div style="font-size: 24px; font-weight: 700; color: #28a745;">{{ MassEmailSuccessCount }}</div>
            <div style="font-size: 11px; color: #666; text-transform: uppercase;">{{ 'Successful' | translate }}</div>
          </div>
          <div style="text-align: center; padding: 12px 20px; background: #ffebee; border-radius: 8px;">
            <div style="font-size: 24px; font-weight: 700; color: #dc3545;">{{ MassEmailErrorCount }}</div>
            <div style="font-size: 11px; color: #666; text-transform: uppercase;">{{ 'Failed' | translate }}</div>
          </div>
        </div>

        <!-- Loading Animation -->
        <div style="display: flex; justify-content: center; margin-top: 20px;" *ngIf="MassEmailProgressPercent < 100">
          <mat-spinner [diameter]="24"></mat-spinner>
        </div>
      </div>
    </div>
  </div>

  <!-- MASS Email Results Popup -->
  <div class="ModernPopupOverlay" *ngIf="ShowMassEmailResultsPopup == true;">
    <div class="ModernPopup large animated fadeInDown">
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons">mark_email_read</i>
          {{ 'MassEmailResults' | translate }}
        </div>
        <button class="ModernPopupClose" (click)="CloseMassEmailResultsPopup();">
          <i class="material-icons">close</i>
        </button>
      </div>

      <div class="ModernPopupBody" style="max-height: 60vh; overflow-y: auto;">
        <!-- Summary -->
        <div class="MassEmailResultsSummary" style="display: flex; gap: 20px; margin-bottom: 20px; padding: 16px; background: #f8f9fa; border-radius: 8px;">
          <div style="flex: 1; text-align: center;">
            <div style="font-size: 28px; font-weight: 700; color: #28a745;">{{ MassEmailSuccessCount }}</div>
            <div style="font-size: 12px; color: #666;">{{ 'Successful' | translate }}</div>
          </div>
          <div style="flex: 1; text-align: center;">
            <div style="font-size: 28px; font-weight: 700; color: #dc3545;">{{ MassEmailErrorCount }}</div>
            <div style="font-size: 12px; color: #666;">{{ 'Failed' | translate }}</div>
          </div>
        </div>

        <!-- Results List -->
        <div class="MassEmailResultsList">
          <div *ngFor="let agent of AllPartnerAgents"
               [hidden]="!agent.EmailSendStatus"
               class="MassEmailResultRow"
               style="display: flex; align-items: center; padding: 12px 16px; border-bottom: 1px solid #f0f0f0;">
            <!-- Status Indicator -->
            <div class="MassEmailResultStatus" style="margin-right: 12px;">
              <i class="material-icons" [style.color]="agent.EmailSendStatus === 'Success' ? '#28a745' : '#dc3545'"
                 [matTooltip]="agent.EmailSendStatus === 'Error' ? agent.EmailSendError : ('EmailSentSuccessfully' | translate)">
                {{ agent.EmailSendStatus === 'Success' ? 'check_circle' : 'error' }}
              </i>
            </div>

            <!-- Partner Name -->
            <div style="flex: 1;">
              <div style="font-size: 13px; font-weight: 600; color: #333;">{{ agent.Partner?.Name }}</div>
              <div style="font-size: 12px; color: #666;">{{ agent.FirstName }} {{ agent.LastName }}</div>
            </div>

            <!-- Email -->
            <div style="font-size: 12px; color: #888;">{{ agent.Email }}</div>

            <!-- Error Message (if any) -->
            <div *ngIf="agent.EmailSendStatus === 'Error'" style="margin-left: 12px;">
              <i class="material-icons" style="font-size: 18px; color: #dc3545; cursor: help;"
                 [matTooltip]="agent.EmailSendError">
                info_outline
              </i>
            </div>
          </div>
        </div>
      </div>

      <div class="ModernPopupFooter">
        <button class="ModernButton primary" (click)="CloseMassEmailResultsPopup();">
          <i class="material-icons">check</i>
          {{ 'Close' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modern Info Question - Generate Partners Search Results -->
  <div class="ModernInfoQuestion animated fadeInDown" *ngIf="ShowGeneratePartnersSearchResultsPopUp">
    <div class="ModernInfoQuestionHeader">
      <div class="ModernInfoQuestionIcon">
        <i class="material-icons">file_download</i>
      </div>
      <div class="ModernInfoQuestionTitle">{{ 'GeneratePartnersSearchResults' | translate }}</div>
    </div>
    <div class="ModernInfoQuestionBody">
      <p class="ModernInfoQuestionText">{{ 'GeneratePartnersSearchResultsDescription' | translate }}</p>
    </div>
    <div class="ModernInfoQuestionFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowGeneratePartnersSearchResultsPopUp = false;">
        {{ 'Configuration.DeleteNoButton' | translate }}
      </button>
      <button class="ModernButton primary" [disabled]="this.parent.loading" (click)="ShowGeneratePartnersSearchResultsPopUp = false; GeneratePartnersSearchResults();">
        <i class="material-icons">check</i>
        {{ 'GeneratePartnersSearchResults' | translate }}
      </button>
    </div>
  </div>

  <!-- Modern Info Question - Delete Profit Settings -->
  <div class="ModernInfoQuestion animated fadeInDown" *ngIf="ShowDeleteProfitMessage">
    <div class="ModernInfoQuestionHeader">
      <div class="ModernInfoQuestionIcon danger">
        <i class="material-icons">warning</i>
      </div>
      <div class="ModernInfoQuestionTitle">{{ 'Configuration.DeleteQuestion' | translate }}</div>
    </div>
    <div class="ModernInfoQuestionBody">
      <p class="ModernInfoQuestionText">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
    </div>
    <div class="ModernInfoQuestionFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowDeleteProfitMessage = false;">
        {{ 'Configuration.DeleteNoButton' | translate }}
      </button>
      <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowDeleteProfitMessage = false; DeleteProfitSettings();">
        <i class="material-icons">delete</i>
        {{ 'Configuration.DeleteYesButton' | translate }}
      </button>
    </div>
  </div>

  <!-- Modern Info Question - Delete Restriction -->
  <div class="ModernInfoQuestion animated fadeInDown" *ngIf="ShowDeleteRestrictionQuestion">
    <div class="ModernInfoQuestionHeader">
      <div class="ModernInfoQuestionIcon danger">
        <i class="material-icons">warning</i>
      </div>
      <div class="ModernInfoQuestionTitle">{{ 'Configuration.DeleteQuestion' | translate }}</div>
    </div>
    <div class="ModernInfoQuestionBody">
      <p class="ModernInfoQuestionText">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
    </div>
    <div class="ModernInfoQuestionFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowDeleteRestrictionQuestion = false;">
        {{ 'Configuration.DeleteNoButton' | translate }}
      </button>
      <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowDeleteRestrictionQuestion = false; DeletePartnerB2BRestriction(this.DeletingRestriction);">
        <i class="material-icons">delete</i>
        {{ 'Configuration.DeleteYesButton' | translate }}
      </button>
    </div>
  </div>

  <!-- Modern Info Question - Delete Year Settings -->
  <div class="ModernInfoQuestion animated fadeInDown" *ngIf="ShowDeleteYearSettingsQuestion">
    <div class="ModernInfoQuestionHeader">
      <div class="ModernInfoQuestionIcon danger">
        <i class="material-icons">warning</i>
      </div>
      <div class="ModernInfoQuestionTitle">{{ 'Configuration.DeleteQuestion' | translate }}</div>
    </div>
    <div class="ModernInfoQuestionBody">
      <p class="ModernInfoQuestionText">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
    </div>
    <div class="ModernInfoQuestionFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowDeleteYearSettingsQuestion = false;">
        {{ 'Configuration.DeleteNoButton' | translate }}
      </button>
      <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowDeleteYearSettingsQuestion = false; DeletePartnersB2BHistoryYearSettings(this.CurrentYearSettings);">
        <i class="material-icons">delete</i>
        {{ 'Configuration.DeleteYesButton' | translate }}
      </button>
    </div>
  </div>

  <div class="NewProfitSettingsContainer animated fadeInDown" *ngIf="ShowNewProfitSettings == true;">
    <div class="NewProfitSettingsContainerTitle">{{'AddNewProfitSettings' | translate}}</div>
    <div class="NewProfitSettingsContainerClose" (click)="this.ShowNewProfitSettings = false;">
      <i class="material-icons">close</i>
    </div>

    <div class="NewProfitSettingsContainerBody">

      <div class="NewProfitSettingsContainerBodyRow">
        <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
          <label class="ModernFormLabel required">{{ 'Client' | translate }}</label>
          <input class="ModernFormInput" type="text" disabled [(ngModel)]="this.ProfitSettings.PartnerName">
        </div>
       </div>

       <div class="NewProfitSettingsContainerBodyRow" *ngIf="this.ProfitSettings?.PercentageImpact?.PercentageProfitMargin != null">
        <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
          <label class="ModernFormLabel required">% {{ 'OurProfit' | translate }}</label>
          <input class="ModernFormInput" type="text" disabled [(ngModel)]="this.ProfitSettings.PercentageImpact.PercentageProfitMargin">
        </div>
       </div>

       <div class="NewProfitSettingsContainerBodyRow">
        <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
          <label class="ModernFormLabel required">{{'SearchConfiguration' | translate}}</label>
          <div class="ModernDropdownContainer">
            <input class="ModernFormInput" type="text"
                   placeholder="{{'SearchConfiguration' | translate}}"
                   [(ngModel)]="this.ConfigurationTerm"
                   (click)="InitializeImportConfigurations(); showConfigurationDropdown = true;"
                   (ngModelChange)="this.configSearchTermUpdate.next($event)">
            <div class="ModernDropdownResults" *ngIf="showConfigurationDropdown && ImportConfigurations?.length > 0" style="top: 100%; margin-top: 4px;">
              <div class="ModernDropdownOption" *ngFor="let c of ImportConfigurations" (click)="SelectConfiguration(c); showConfigurationDropdown = false;">
                {{c.Name}}
              </div>
            </div>
          </div>
        </div>
       </div>

       <div class="NewProfitSettingsContainerBodyRow" *ngIf="this.ProfitSettings?.ImportConfiguration?.DiscountedGroups?.length > 0;">
        <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
          <label class="ModernFormLabel">{{ 'SearchGroup' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownOverlay" *ngIf="showGroupDropdown" (click)="showGroupDropdown = false;"></div>
            <div class="ModernDropdownBar" [class.open]="showGroupDropdown" (click)="showGroupDropdown = !showGroupDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!this.ProfitSettings?.DiscountGroup">
                {{ this.ProfitSettings?.DiscountGroup ? this.ProfitSettings.DiscountGroup.GroupName + ' (' + this.ProfitSettings.DiscountGroup.DiscountValue + '%)' : ('Select' | translate) }}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="showGroupDropdown">
              <div class="ModernDropdownOption" *ngFor="let g of this.ProfitSettings?.ImportConfiguration?.DiscountedGroups"
                   [class.selected]="this.ProfitSettings?.DiscountGroup?.GroupName === g.GroupName"
                   (click)="this.ProfitSettings.DiscountGroup = g; showGroupDropdown = false;">
                {{g.GroupName}} ({{g.DiscountValue}}% {{'PurchaseDiscount' | translate}})
                <i class="material-icons check-icon" *ngIf="this.ProfitSettings?.DiscountGroup?.GroupName === g.GroupName">check</i>
              </div>
            </div>
          </div>
        </div>
       </div>

     <div class="NewProfitSettingsContainerBodyRow">
      <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
        <label class="ModernFormLabel">{{'SelectBrand' | translate}}</label>
        <div class="ModernDropdownContainer">
          <input class="ModernFormInput" type="text"
                 placeholder="{{'SelectBrand' | translate}}"
                 [(ngModel)]="this.BrandSearchTerm"
                 (click)="InitializeBrands(); showBrandDropdown = true;"
                 (ngModelChange)="this.brandSearchTermUpdate.next($event)">
          <div class="ModernDropdownResults" *ngIf="showBrandDropdown && Brands?.length > 0" style="top: 100%; margin-top: 4px;">
            <div class="ModernDropdownOption" *ngFor="let brand of Brands" (click)="this.Brand = brand; this.BrandSearchTerm = brand.Name; this.ProfitSettings.Brand = brand; showBrandDropdown = false;">
              {{brand.Name}}
            </div>
          </div>
        </div>
      </div>
     </div>

     <div class="NewProfitSettingsContainerBodyRow">
      <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;" matTooltip="{{this.ProfitSettings?.PercentageImpact?.Description}}" matTooltipClass='neutral-tool-tip-management'>
        <label class="ModernFormLabel">{{ 'ProfitSettingsPercentageImpact' | translate }}</label>
        <div class="ModernDropdownContainer">
          <div class="ModernDropdownOverlay" *ngIf="showPercentageImpactDropdown" (click)="showPercentageImpactDropdown = false;"></div>
          <div class="ModernDropdownBar" [class.open]="showPercentageImpactDropdown" (click)="showPercentageImpactDropdown = !showPercentageImpactDropdown">
            <span class="ModernDropdownText" [class.placeholder]="!this.ProfitSettings?.PercentageImpact">
              {{ this.ProfitSettings?.PercentageImpact?.Name || ('Select' | translate) }}
            </span>
            <i class="material-icons ModernDropdownArrow">expand_more</i>
          </div>
          <div class="ModernDropdownResults" *ngIf="showPercentageImpactDropdown">
            <div class="ModernDropdownOption" *ngFor="let p of this.ProfitSettingsPercentageImpacts"
                 [class.selected]="this.ProfitSettings?.PercentageImpact?.ID === p.ID"
                 (click)="this.ProfitSettings.PercentageImpact = p; showPercentageImpactDropdown = false;">
              {{p.Name}}
              <i class="material-icons check-icon" *ngIf="this.ProfitSettings?.PercentageImpact?.ID === p.ID">check</i>
            </div>
          </div>
        </div>
      </div>
     </div>

     <div class="NewProfitSettingsContainerBodyRow">
      <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
        <label class="ModernFormLabel required">
          <span *ngIf="this.ProfitSettings?.PercentageImpact?.ID == 0">{{ 'PriceListDiscountClient' | translate }}</span>
          <span *ngIf="this.ProfitSettings?.PercentageImpact?.ID == 1">{{ 'PureProfitFromPurchasePrice' | translate }}</span>
        </label>
        <input class="ModernFormInput" type="text" placeholder="{{ 'Percentage' | translate }}" autocomplete="off" [(ngModel)]="this.ProfitSettings.Percentage">
      </div>
     </div>

     <div class="NewProfitSettingsContainerBodyRow">
      <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
        <label class="ModernFormLabel required">{{ 'ExtraAddedValue' | translate }}</label>
        <input class="ModernFormInput" type="text" placeholder="{{ 'ExtraAddedValue' | translate }}" autocomplete="off" [(ngModel)]="this.ProfitSettings.ExtraAddedValue">
      </div>
     </div>

     <div class="NewProfitSettingsContainerBodyRow">
      <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
        <label class="ModernFormLabel required">{{ 'ExtraAddedPercentageValue' | translate }}</label>
        <input class="ModernFormInput" type="text" placeholder="{{ 'ExtraAddedPercentageValue' | translate }}" autocomplete="off" [(ngModel)]="this.ProfitSettings.ExtraAddedPercentageValue">
      </div>
     </div>
    </div>

    <div class="NewProfitSettingsContainerCommands">
      <button class="GridCommandButton success" (click)="AddUpdatePartnerProfitSettings();">
        <i class="material-icons">save_alt</i>
        <span>{{'SaveButton' | translate}}</span>
      </button>

      <button class="GridCommandButton danger" (click)="this.ShowDeleteProfitMessage = true;">
        <i class="material-icons">close</i>
        <span>{{'Delete' | translate}}</span>
      </button>
    </div>
  </div>

  <div class="NewProfitSettingsContainer animated fadeInDown" *ngIf="ShowNewRestrictionSettings == true;">
    <div class="NewProfitSettingsContainerTitle">{{'AddNewRestrictionSettings' | translate}}</div>
    <div class="NewProfitSettingsContainerClose" (click)="this.ShowNewRestrictionSettings = false;">
      <i class="material-icons">close</i>
    </div>

    <div class="NewProfitSettingsContainerBody">

      <div class="NewProfitSettingsContainerBodyRow">
        <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
          <label class="ModernFormLabel required">{{ 'Client' | translate }}</label>
          <input class="ModernFormInput" type="text" disabled [(ngModel)]="this.Partner.Name">
        </div>
       </div>

       <div class="NewProfitSettingsContainerBodyRow">
        <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
          <label class="ModernFormLabel">{{ 'RestrictionType' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownOverlay" *ngIf="showRestrictionTypeDropdown" (click)="showRestrictionTypeDropdown = false;"></div>
            <div class="ModernDropdownBar" [class.open]="showRestrictionTypeDropdown" (click)="showRestrictionTypeDropdown = !showRestrictionTypeDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!this.Restriction?.Type">
                {{ this.Restriction?.Type?.Name || ('Select' | translate) }}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="showRestrictionTypeDropdown">
              <div class="ModernDropdownOption" *ngFor="let t of this.RestrictionTypes"
                   [class.selected]="this.Restriction?.Type?.ID === t.ID"
                   (click)="this.Restriction.Type = t; SelectRestrictionType(t); showRestrictionTypeDropdown = false;">
                {{t.Name}}
                <i class="material-icons check-icon" *ngIf="this.Restriction?.Type?.ID === t.ID">check</i>
              </div>
            </div>
          </div>
        </div>
       </div>

       <div class="NewProfitSettingsContainerBodyRow">
        <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
          <label class="ModernFormLabel required">{{'SearchConfiguration' | translate}}</label>
          <div class="ModernDropdownContainer">
            <input class="ModernFormInput" type="text"
                   placeholder="{{'SearchConfiguration' | translate}}"
                   [(ngModel)]="this.ConfigurationTerm"
                   (click)="InitializeImportConfigurations(); showRestrictionConfigDropdown = true;"
                   (ngModelChange)="this.configSearchTermUpdate.next($event)"
                   [disabled]="this.Restriction?.Type?.ID != -1">
            <div class="ModernDropdownResults" *ngIf="showRestrictionConfigDropdown && ImportConfigurations?.length > 0 && this.Restriction?.Type?.ID == -1" style="top: 100%; margin-top: 4px;">
              <div class="ModernDropdownOption" *ngFor="let c of ImportConfigurations" (click)="SelectRestrictionConfiguration(c); showRestrictionConfigDropdown = false;">
                {{c.Name}}
              </div>
            </div>
          </div>
        </div>
       </div>

     <div class="NewProfitSettingsContainerBodyRow">
      <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
        <label class="ModernFormLabel">{{'SelectBrand' | translate}}</label>
        <div class="ModernDropdownContainer">
          <input class="ModernFormInput" type="text"
                 placeholder="{{'SelectBrand' | translate}}"
                 [(ngModel)]="this.BrandSearchTerm"
                 (click)="InitializeBrands(); showRestrictionBrandDropdown = true;"
                 (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                 [disabled]="this.Restriction?.Type?.ID != 1">
          <div class="ModernDropdownResults" *ngIf="showRestrictionBrandDropdown && Brands?.length > 0 && this.Restriction?.Type?.ID == 1" style="top: 100%; margin-top: 4px;">
            <div class="ModernDropdownOption" *ngFor="let brand of Brands" (click)="this.Brand = brand; this.BrandSearchTerm = brand.Name; this.Restriction.RestrictedBrand = brand; showRestrictionBrandDropdown = false;">
              {{brand.Name}}
            </div>
          </div>
        </div>
      </div>
     </div>

     <div class="NewProfitSettingsContainerBodyRow">
      <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
        <label class="ModernFormLabel">{{'SelectCountry' | translate}}</label>
        <div class="ModernDropdownContainer">
          <input class="ModernFormInput" type="text"
                 placeholder="{{'SelectCountry' | translate}}"
                 [(ngModel)]="this.CountrySearchTerm"
                 (click)="InitializeCountries(); showRestrictionCountryDropdown = true;"
                 (ngModelChange)="this.countrySearchTermUpdate.next($event)"
                 [disabled]="this.Restriction?.Type?.ID != 2">
          <div class="ModernDropdownResults" *ngIf="showRestrictionCountryDropdown && SpareCountries?.length > 0 && this.Restriction?.Type?.ID == 2" style="top: 100%; margin-top: 4px;">
            <div class="ModernDropdownOption" *ngFor="let c of SpareCountries" (click)="SelectRestrictionCountry(c); showRestrictionCountryDropdown = false;">
              {{c.Name}}
            </div>
          </div>
        </div>
      </div>
     </div>
    </div>

    <div class="NewProfitSettingsContainerCommands">
      <button class="GridCommandButton success" (click)="AddUpdatePartnerB2BRestriction();">
        <i class="material-icons">save_alt</i>
        <span>{{'SaveButton' | translate}}</span>
      </button>

      <button class="GridCommandButton danger" (click)="this.ShowNewRestrictionSettings = true;">
        <i class="material-icons">close</i>
        <span>{{'Delete' | translate}}</span>
      </button>
    </div>
  </div>

  <div class="NewProfitSettingsContainer animated fadeInDown" style="height: 40vh;" *ngIf="ShowNewYearSettingsBrandChange == true;">
    <div class="NewProfitSettingsContainerTitle">{{'ChooseBrand' | translate}}</div>
    <div class="NewProfitSettingsContainerClose" (click)="this.ShowNewYearSettingsBrandChange = false;">
      <i class="material-icons">close</i>
    </div>

    <div class="NewProfitSettingsContainerBody">
     <div class="NewProfitSettingsContainerBodyRow">
      <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
        <label class="ModernFormLabel">{{'SelectBrand' | translate}}</label>
        <div class="ModernDropdownContainer">
          <input class="ModernFormInput" type="text"
                 placeholder="{{'SelectBrand' | translate}}"
                 [(ngModel)]="this.BrandSearchTerm"
                 (click)="InitializeBrands(); showNewYearBrandDropdown = true;"
                 (ngModelChange)="this.brandSearchTermUpdateForNewYearSettings.next($event)">
          <div class="ModernDropdownResults" *ngIf="showNewYearBrandDropdown && Brands?.length > 0" style="top: 100%; margin-top: 4px;">
            <div class="ModernDropdownOption" *ngFor="let brand of Brands" (click)="this.Brand = brand; this.BrandSearchTerm = brand.Name; SelectBrandForNewYearsSetting(brand); showNewYearBrandDropdown = false;">
              {{brand.Name}}
            </div>
          </div>
        </div>
      </div>
     </div>
    </div>

    <div class="NewProfitSettingsContainerCommands">
      <button class="GridCommandButton success" (click)="this.ShowNewYearSettingsBrandChange = false;">
        <i class="material-icons">save_alt</i>
        <span>{{'SaveButton' | translate}}</span>
      </button>
    </div>
  </div>

  <div class="NewProfitSettingsContainer animated fadeInDown" style="height: 40vh;" *ngIf="ShowYearSettingsBrandChange == true;">
    <div class="NewProfitSettingsContainerTitle">{{'ChooseBrand' | translate}}</div>
    <div class="NewProfitSettingsContainerClose" (click)="this.ShowYearSettingsBrandChange = false;">
      <i class="material-icons">close</i>
    </div>

    <div class="NewProfitSettingsContainerBody">
     <div class="NewProfitSettingsContainerBodyRow">
      <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
        <label class="ModernFormLabel">{{'SelectBrand' | translate}}</label>
        <div class="ModernDropdownContainer">
          <input class="ModernFormInput" type="text"
                 placeholder="{{'SelectBrand' | translate}}"
                 [(ngModel)]="this.BrandSearchTerm"
                 (click)="InitializeBrands(); showYearBrandDropdown = true;"
                 (ngModelChange)="this.brandSearchTermUpdateForYearSettings.next($event)">
          <div class="ModernDropdownResults" *ngIf="showYearBrandDropdown && Brands?.length > 0" style="top: 100%; margin-top: 4px;">
            <div class="ModernDropdownOption" *ngFor="let brand of Brands" (click)="this.Brand = brand; this.BrandSearchTerm = brand.Name; SelectBrandForYearsSetting(brand); showYearBrandDropdown = false;">
              {{brand.Name}}
            </div>
          </div>
        </div>
      </div>
     </div>
    </div>

    <div class="NewProfitSettingsContainerCommands">
      <button class="GridCommandButton success" (click)="this.ShowYearSettingsBrandChange = false;">
        <i class="material-icons">save_alt</i>
        <span>{{'SaveButton' | translate}}</span>
      </button>
    </div>
  </div>

  <!-- Modern Info Question - Delete Partner Agent -->
  <div class="ModernInfoQuestion animated fadeInDown" *ngIf="ShowPartnerAgentDeleteMessage">
    <div class="ModernInfoQuestionHeader">
      <div class="ModernInfoQuestionIcon danger">
        <i class="material-icons">warning</i>
      </div>
      <div class="ModernInfoQuestionTitle">{{ 'Configuration.DeleteQuestion' | translate }}</div>
    </div>
    <div class="ModernInfoQuestionBody">
      <p class="ModernInfoQuestionText">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
    </div>
    <div class="ModernInfoQuestionFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowPartnerAgentDeleteMessage = false;">
        {{ 'Configuration.DeleteNoButton' | translate }}
      </button>
      <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowPartnerAgentDeleteMessage = false; DeletePartnerAgent(this.PartnerAgent.ID);">
        <i class="material-icons">delete</i>
        {{ 'Configuration.DeleteYesButton' | translate }}
      </button>
    </div>
  </div>

  <!-- Modern Info Question - Delete Partner Address -->
  <div class="ModernInfoQuestion animated fadeInDown" *ngIf="ShowPartnerAddressDeleteMessage">
    <div class="ModernInfoQuestionHeader">
      <div class="ModernInfoQuestionIcon danger">
        <i class="material-icons">warning</i>
      </div>
      <div class="ModernInfoQuestionTitle">{{ 'Configuration.DeleteQuestion' | translate }}</div>
    </div>
    <div class="ModernInfoQuestionBody">
      <p class="ModernInfoQuestionText">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
    </div>
    <div class="ModernInfoQuestionFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowPartnerAddressDeleteMessage = false;">
        {{ 'Configuration.DeleteNoButton' | translate }}
      </button>
      <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowPartnerAddressDeleteMessage = false; DeletePartnerShippingAddress(this.CurrentShippingAddress);">
        <i class="material-icons">delete</i>
        {{ 'Configuration.DeleteYesButton' | translate }}
      </button>
    </div>
  </div>

  <!-- Modern Partner Form Popup -->
  <div class="ModernPopupOverlay" *ngIf="ShowAddNewPartnerForm == true;">
    <div class="ModernPopup xlarge animated fadeInDown" style="height: 90vh;">
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons">{{this.Partner.ID == null ? 'person_add' : 'edit'}}</i>
          <span *ngIf="this.Partner.ID == null;">{{'AddNewPartner' | translate}}</span>
          <span *ngIf="this.Partner.ID?.length > 0;">{{'ModifyPartner' | translate}}: {{this.Partner.Name}} ({{this.Partner.Code}})</span>
        </div>
        <button class="ModernPopupClose" (click)="ShowAddNewPartnerForm = false;">
          <i class="material-icons">close</i>
        </button>
      </div>

      <!-- Tab Navigation -->
      <div class="GridCommandCenter" style="padding: 12px 20px; background: #f8f9fa; border-bottom: 1px solid #e9ecef; margin: 0; width: auto;min-height: 100px;">
        <button class="GridCommandButton" [class.primary]="ShowBillingInfo"
                (click)="ShowB2BRestrictions = false; ShowBillingInfo = true; ShowShippingInfo = false; ShowAgentsInfo = false; ShowProcessingSettings = false; ShowProfitSettings = false; ShowContractualConditions = false; ShowAcceptedEmailDomains = false;">
          <i class="material-icons">receipt</i>
          {{'ViewBillingInformation' | translate}}
        </button>

        <button class="GridCommandButton" [class.primary]="ShowShippingInfo" *ngIf="this.Partner.ID?.length > 0"
                (click)="ShowB2BRestrictions = false; ShowShippingInfo = true; ShowBillingInfo = false; ShowAgentsInfo = false; ShowProcessingSettings = false; ShowProfitSettings = false; ShowContractualConditions = false; ShowAcceptedEmailDomains = false;">
          <i class="material-icons">local_shipping</i>
          {{'ViewShippingInformation' | translate}}
        </button>

        <button class="GridCommandButton" [class.primary]="ShowAgentsInfo" *ngIf="this.Partner.ID?.length > 0"
                (click)="ShowB2BRestrictions = false; ShowShippingInfo = false; ShowBillingInfo = false; ShowAgentsInfo = true; ShowProcessingSettings = false; ShowProfitSettings = false; ShowContractualConditions = false; ShowAcceptedEmailDomains = false; GetPartnerAgents(this.Partner.ID);">
          <i class="material-icons">people</i>
          {{'ViewAgentsInformation' | translate}}
        </button>

        <button class="GridCommandButton" [class.primary]="ShowProfitSettings" *ngIf="this.Partner.ID?.length > 0"
                (click)="ShowB2BRestrictions = false; ShowShippingInfo = false; ShowBillingInfo = false; ShowAgentsInfo = false; ShowProcessingSettings = false; ShowProfitSettings = true; ShowContractualConditions = false; ShowAcceptedEmailDomains = false; GetPartnerProfitSettings();">
          <i class="material-icons">trending_up</i>
          {{'ViewProfitSettings' | translate}}
        </button>

        <button class="GridCommandButton" [class.primary]="ShowProcessingSettings" *ngIf="this.Partner.ID?.length > 0"
                (click)="ShowB2BRestrictions = false; ShowShippingInfo = false; ShowBillingInfo = false; ShowAgentsInfo = false; ShowProfitSettings = false; ShowProcessingSettings = true; ShowContractualConditions = false; ShowAcceptedEmailDomains = false; GetPartnerProcessingSettings();">
          <i class="material-icons">settings</i>
          {{'ProcessingSettings' | translate}}
        </button>

        <button class="GridCommandButton" [class.primary]="ShowB2BRestrictions" *ngIf="this.Partner.ID?.length > 0"
                (click)="ShowB2BRestrictions = true; ShowShippingInfo = false; ShowBillingInfo = false; ShowAgentsInfo = false; ShowProfitSettings = false; ShowProcessingSettings = false; ShowContractualConditions = false; ShowAcceptedEmailDomains = false; GetPartnerB2BRestictions(); GetPartnerB2BSettings(); GetB2BPartnerConnectedUser();">
          <i class="material-icons">security</i>
          {{'B2BSettingsAndRestrictions' | translate}}
        </button>

        <button class="GridCommandButton" [class.primary]="ShowContractualConditions" *ngIf="this.Partner.ID?.length > 0"
                (click)="ShowB2BRestrictions = false; ShowShippingInfo = false; ShowBillingInfo = false; ShowAgentsInfo = false; ShowProfitSettings = false; ShowProcessingSettings = false; ShowContractualConditions = true; ShowAcceptedEmailDomains = false; GetPartnerContractualConditions();">
          <i class="material-icons">description</i>
          {{'ContractualConditions' | translate}}
        </button>

        <button class="GridCommandButton" [class.primary]="ShowAcceptedEmailDomains" *ngIf="this.Partner.ID?.length > 0"
                (click)="ShowB2BRestrictions = false; ShowShippingInfo = false; ShowBillingInfo = false; ShowAgentsInfo = false; ShowProfitSettings = false; ShowProcessingSettings = false; ShowContractualConditions = false; ShowAcceptedEmailDomains = true; GetPartnerAcceptedDomains();">
          <i class="material-icons">email</i>
          {{'AcceptedEmailDomains' | translate}}
        </button>
      </div>

      <div class="ModernPopupBody" style="height: calc(90vh - 180px); padding: 20px;">

      <div *ngIf="ShowBillingInfo" class="fullWidth">
        <div class="ModernFormHalf">

          <div class="ModernFormSectionTitle">
            <i class="material-icons">business</i>
            {{'GeneralInformation' | translate}}
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Name' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'Name' | translate }}" autocomplete="off" [(ngModel)]="this.Partner.Name">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'VAT' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'VAT' | translate }}" autocomplete="off" [(ngModel)]="this.Partner.VAT">
          </div>

          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="this.Partner.TaxPayer">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'TaxPayer' | translate}}</span>
          </div>

          <div class="ModernFormGroup">
            <button class="ModernActionButton verify" (click)="GetPartnerEUData(this.Partner);">
              <i class="material-icons" *ngIf="this.Partner.EUVATVerified" matTooltip="{{ 'EUVATVerifiedDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>verified_user</i>
              <i class="material-icons" *ngIf="!this.Partner.EUVATVerified" style="color: #fff;">gpp_maybe</i>
              {{'VerifyEUVATVIES' | translate}}
            </button>
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'UPN' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'UPN' | translate }}" autocomplete="off" [(ngModel)]="this.Partner.UPN">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'COCRegNumber' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'COCRegNumber' | translate }}" autocomplete="off" [(ngModel)]="this.Partner.COCRegNumber">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'EventRegister' | translate }}</label>
            <input type="text" class="ModernFormInput" disabled placeholder="{{ 'EventRegister' | translate }}" autocomplete="off" [(ngModel)]="this.Partner.RegisteredUI">
          </div>

          <div class="ModernFormSectionTitle" style="margin-top: 24px;">
            <i class="material-icons">location_on</i>
            {{'BillingAddress' | translate}}
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel">{{ 'Country' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showBillingCountryDropdown" (click)="showBillingCountryDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showBillingCountryDropdown" (click)="showBillingCountryDropdown = !showBillingCountryDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!this.Partner.BillingAddress?.Country">
                  {{this.Partner.BillingAddress?.Country?.Name || ('SelectCountry' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showBillingCountryDropdown">
                <div class="ModernDropdownOption" *ngFor="let c of this.Countries"
                     [class.selected]="this.Partner.BillingAddress?.Country?.ID === c.ID"
                     (click)="this.Partner.BillingAddress.Country = c; showBillingCountryDropdown = false;">
                  {{c.Name}}
                  <i class="material-icons check-icon" *ngIf="this.Partner.BillingAddress?.Country?.ID === c.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'StateProvince' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'StateProvince' | translate }}" autocomplete="off" [(ngModel)]="this.Partner.BillingAddress.StateProvince">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'City' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'City' | translate }}" autocomplete="off" [(ngModel)]="this.Partner.BillingAddress.City">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Address' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'Address' | translate }}" autocomplete="off" [(ngModel)]="this.Partner.BillingAddress.AddressLine">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'ZipCode' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'ZipCode' | translate }}" autocomplete="off" [(ngModel)]="this.Partner.BillingAddress.ZipCode">
          </div>
        </div>
        <div class="ModernFormHalf">
          <div class="ModernFormSectionTitle">
            <i class="material-icons">account_balance</i>
            {{'Partners.PartnerWindow.Bank' | translate}}
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel">{{ 'Partners.PartnerWindow.Bank' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showBankDropdown" (click)="showBankDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showBankDropdown" (click)="showBankDropdown = !showBankDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!this.Partner.Bank">
                  {{this.Partner.Bank?.Name || ('SelectBank' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showBankDropdown">
                <div class="ModernDropdownOption" *ngFor="let b of this.Banks"
                     [class.selected]="this.Partner.Bank?.ID === b.ID"
                     (click)="this.Partner.Bank = b; SwitchPartnerBank(b); showBankDropdown = false;">
                  {{b.Name}}
                  <i class="material-icons check-icon" *ngIf="this.Partner.Bank?.ID === b.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Partners.PartnerWindow.Bank' | translate }}</label>
            <input type="text" class="ModernFormInput" disabled placeholder="{{ 'Partners.PartnerWindow.Bank' | translate }}" autocomplete="off" [(ngModel)]="this.Partner.Bank.Name">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Swift' | translate }}</label>
            <input type="text" class="ModernFormInput" disabled placeholder="{{ 'Swift' | translate }}" autocomplete="off" [(ngModel)]="this.Partner.Bank.Swift">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}" autocomplete="off" [(ngModel)]="this.Partner.Bank.BankAccount">
          </div>

          <div class="ModernFormSectionTitle" style="margin-top: 24px;">
            <i class="material-icons">person</i>
            {{'Partners.PartnerWindow.ContactInfo' | translate}}
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel">Email</label>
            <input type="email" class="ModernFormInput" placeholder="Email" autocomplete="off" [(ngModel)]="this.Partner.ContactInfo.Email">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Partners.PartnerWindow.Name' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'Partners.PartnerWindow.Name' | translate }}" autocomplete="off" [(ngModel)]="this.Partner.ContactInfo.Name">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Login.Phone' | translate }}</label>
            <input type="tel" class="ModernFormInput" placeholder="{{ 'Login.Phone' | translate }}" autocomplete="off" [(ngModel)]="this.Partner.ContactInfo.Phone">
          </div>

        </div>
      </div>

      <div *ngIf="ShowShippingInfo" class="fullWidth" style="height: auto; float: left; padding: 0;">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">local_shipping</i>
          {{'ShippingAddresses' | translate}}
        </div>

        <div style="margin-bottom: 20px;">
          <button class="ModernActionButton success" (click)="GenerateInitialShippingAddress();">
            <i class="material-icons">add</i>
            {{'GenerateInitialShippingAddress' | translate}}
          </button>
        </div>

        <div class="ModernFormGroup" *ngIf="this.Partner.ShippingAddresses?.length > 0;">
          <label class="ModernFormLabel">{{ 'ShippingAddresses' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownOverlay" *ngIf="showShippingAddressDropdown" (click)="showShippingAddressDropdown = false"></div>
            <div class="ModernDropdownBar" [class.open]="showShippingAddressDropdown" (click)="showShippingAddressDropdown = !showShippingAddressDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!this.CurrentShippingAddress">
                {{this.CurrentShippingAddress ? (this.CurrentShippingAddress.Country?.Name + ' ' + this.CurrentShippingAddress.City + ' ' + this.CurrentShippingAddress.AddressLine) : ('SelectAddress' | translate)}}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="showShippingAddressDropdown">
              <div class="ModernDropdownOption" *ngFor="let a of this.Partner.ShippingAddresses"
                   [class.selected]="this.CurrentShippingAddress?.ID === a.ID"
                   (click)="this.CurrentShippingAddress = a; showShippingAddressDropdown = false;">
                {{a.Country?.Name}} {{a.City}} {{a.AddressLine}}
                <i class="material-icons check-icon" *ngIf="this.CurrentShippingAddress?.ID === a.ID">check</i>
              </div>
            </div>
          </div>
        </div>

        <div class="ModernFormHalf" *ngIf="this.Partner.ShippingAddresses?.length > 0;" style="margin-top: 20px;">
          <div class="ModernFormSectionTitle">
            <i class="material-icons">edit_location</i>
            {{'AddressDetails' | translate}}
          </div>

          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="this.CurrentShippingAddress.ActiveAddress">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">
              <span *ngIf="this.CurrentShippingAddress.ActiveAddress == true;">{{'ActiveAddress' | translate}}</span>
              <span *ngIf="this.CurrentShippingAddress.ActiveAddress != true;">{{'DisabledAddress' | translate}}</span>
            </span>
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel">{{ 'Country' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showShippingCountryDropdown" (click)="showShippingCountryDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showShippingCountryDropdown" (click)="showShippingCountryDropdown = !showShippingCountryDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!this.CurrentShippingAddress?.Country">
                  {{this.CurrentShippingAddress?.Country?.Name || ('SelectCountry' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showShippingCountryDropdown">
                <div class="ModernDropdownOption" *ngFor="let c of this.Countries"
                     [class.selected]="this.CurrentShippingAddress?.Country?.ID === c.ID"
                     (click)="this.CurrentShippingAddress.Country = c; showShippingCountryDropdown = false;">
                  {{c.Name}}
                  <i class="material-icons check-icon" *ngIf="this.CurrentShippingAddress?.Country?.ID === c.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'StateProvince' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'StateProvince' | translate }}" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.State">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Partners.PartnerWindow.City' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'Partners.PartnerWindow.City' | translate }}" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.City">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Partners.PartnerWindow.AddressLine' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'Partners.PartnerWindow.AddressLine' | translate }}" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.AddressLine">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'ZipCode' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'ZipCode' | translate }}" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.ZipCode">
          </div>

          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="this.CurrentShippingAddress.IsSelected">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'MainAddress' | translate}}</span>
          </div>

          <button class="ModernActionButton danger" (click)="ShowPartnerAddressDeleteMessage = true;">
            <i class="material-icons">delete</i>
            {{'DeleteButton' | translate}}
          </button>
        </div>

        <div class="ModernFormHalf" *ngIf="this.Partner.ShippingAddresses?.length > 0;" style="margin-top: 20px;">
          <div class="ModernFormSectionTitle">
            <i class="material-icons">person</i>
            {{'Partners.PartnerWindow.ContactInfo' | translate}}
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'Partners.PartnerWindow.ContactInfo' | translate }}" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.ContactPerson">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Company' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'Company' | translate }}" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.ContactCompany">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Email' | translate }}</label>
            <input type="email" class="ModernFormInput" placeholder="{{ 'Email' | translate }}" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.Email">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Login.Phone' | translate }}</label>
            <input type="tel" class="ModernFormInput" placeholder="{{ 'Login.Phone' | translate }}" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.Phone">
          </div>

          <button class="ModernActionButton success" (click)="AddUpdateShippingAddress(this.CurrentShippingAddress, this.Partner.ID);">
            <i class="material-icons">save</i>
            {{'SaveButton' | translate}}
          </button>
        </div>

        <!-- Partner Carrier Accounts Section -->
        <div class="AccountsPanel animated fadeInDown" style="float:left; position: relative; top: 0; left: 0; width: 100%; height: auto; margin-top: 30px; box-shadow: none;">
          <div class="AccountsPanelHeader">
            <p>{{'CarrierAccounts' | translate}}</p>
          </div>

          <div class="AccountsGrid">
            <div class="AccountsGridHeader">
              <div class="AccountsGridCell" style="width: 5%;">#</div>
              <div class="AccountsGridCell" style="width: 20%;">{{'ShippingCompany' | translate}}</div>
              <div class="AccountsGridCell" style="width: 20%;">{{'AccountNumber' | translate}}</div>
              <div class="AccountsGridCell" style="width: 15%;">{{'Direction' | translate}}</div>
              <div class="AccountsGridCell" style="width: 15%;">{{'ServiceType' | translate}}</div>
              <div class="AccountsGridCell" style="width: 15%;">{{'Company' | translate}}</div>
              <div class="AccountsGridCell" style="width: 10%;">{{'Actions' | translate}}</div>
            </div>

            <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="loadingPartnerAccounts == true;"></mat-spinner>

            <div class="AccountsGridRow" *ngFor="let a of PartnerCarrierAccounts; let i = index;">
              <div class="AccountsGridCell" style="width: 5%;">{{i+1}}</div>
              <div class="AccountsGridCell" style="width: 20%;">{{a.ShippingCompanyName}}</div>
              <div class="AccountsGridCell" style="width: 20%;">{{a.AccountNumber}}</div>
              <div class="AccountsGridCell" style="width: 15%;">{{a.ShippingDirection?.Name}}</div>
              <div class="AccountsGridCell" style="width: 15%;">{{a.ShippingServiceType?.Name}}</div>
              <div class="AccountsGridCell" style="width: 15%;">{{a.CompanyName}}</div>
              <div class="AccountsGridCell AccountsGridActions" style="width: 10%;">
                <i class="material-icons" (click)="EditPartnerAccount(a);">edit</i>
                <i class="material-icons" style="color: red;" (click)="DeletePartnerAccount(a);">delete</i>
              </div>
            </div>

            <div class="AccountsGridEmpty" *ngIf="PartnerCarrierAccounts?.length == 0 && loadingPartnerAccounts == false;">
              {{'NoRecordsFound' | translate}}
            </div>
          </div>

          <div class="AccountsPanelCommands">
            <button class="GridCommandButton GridCommandButtonBlue" (click)="OpenNewPartnerAccountPopUp();">
              <i class="material-icons">add</i>
              <span>{{'AddNewAccount' | translate}}</span>
            </button>
          </div>
        </div>

        <!-- Partner Account Add/Edit Popup -->
        <div class="AccountPopUp animated fadeInDown" *ngIf="ShowPartnerAccountPopUp == true;">
          <div class="AccountPopUpHeader">
            <p *ngIf="CurrentPartnerAccount?.ID == 0;">{{'AddNewAccount' | translate}}</p>
            <p *ngIf="CurrentPartnerAccount?.ID != 0;">{{'EditAccount' | translate}}</p>
            <i class="material-icons" (click)="ClosePartnerAccountPopUp();">close</i>
          </div>

          <div class="AccountPopUpBody">
            <!-- Shipping Company Dropdown (Required) -->
            <div class="CustomDropdownContainer" style="width: 100%;">
              <div class="SendEmailOverlayTransparent" *ngIf="showPartnerAccountShippingCompanyDropdown" (click)="showPartnerAccountShippingCompanyDropdown = false"></div>
              <div class="CustomDropdownBar" (click)="showPartnerAccountShippingCompanyDropdown = !showPartnerAccountShippingCompanyDropdown">
                <span class="dropdown-label">{{ 'ShippingCompany' | translate }}*</span>
                <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentPartnerAccount?.ShippingCompany"
                       [value]="CurrentPartnerAccount?.ShippingCompany?.Name || ''"
                       placeholder="{{ 'SelectShippingCompany' | translate }}" readonly />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showPartnerAccountShippingCompanyDropdown">
                <div class="CustomDropdownResult" *ngFor="let s of this.parent.CartMasterData?.ShippingCompanies"
                     (click)="CurrentPartnerAccount.ShippingCompany = s; showPartnerAccountShippingCompanyDropdown = false;">
                  {{s.Name}}
                </div>
              </div>
            </div>

            <!-- Account Number Input -->
            <div class="CustomInputContainer">
              <span class="input-label">{{ 'AccountNumber' | translate }}</span>
              <input type="text" class="CustomTextInput"
                     [(ngModel)]="CurrentPartnerAccount.AccountNumber"
                     placeholder="{{ 'AccountNumber' | translate }}">
            </div>

            <!-- Direction Dropdown -->
            <div class="CustomDropdownContainer" style="width: 100%;">
              <div class="SendEmailOverlayTransparent" *ngIf="showPartnerAccountDirectionDropdown" (click)="showPartnerAccountDirectionDropdown = false"></div>
              <div class="CustomDropdownBar">
                <span class="dropdown-label">{{ 'Direction' | translate }}</span>
                <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentPartnerAccount?.Direction"
                       [value]="CurrentPartnerAccount?.Direction?.Name || ''"
                       placeholder="{{ 'None' | translate }}" readonly
                       (click)="showPartnerAccountDirectionDropdown = !showPartnerAccountDirectionDropdown" />
                <i class="material-icons dropdown-clear" *ngIf="CurrentPartnerAccount?.Direction" (click)="CurrentPartnerAccount.Direction = null; $event.stopPropagation();">close</i>
                <i class="material-icons dropdown-icon" (click)="showPartnerAccountDirectionDropdown = !showPartnerAccountDirectionDropdown">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showPartnerAccountDirectionDropdown">
                <div class="CustomDropdownResult" *ngFor="let d of this.PartnerAccountDirections"
                     (click)="CurrentPartnerAccount.Direction = d; showPartnerAccountDirectionDropdown = false;">
                  {{d.Name}}
                </div>
              </div>
            </div>

            <!-- Service Type Dropdown -->
            <div class="CustomDropdownContainer" style="width: 100%;">
              <div class="SendEmailOverlayTransparent" *ngIf="showPartnerAccountServiceTypeDropdown" (click)="showPartnerAccountServiceTypeDropdown = false"></div>
              <div class="CustomDropdownBar">
                <span class="dropdown-label">{{ 'ServiceType' | translate }}</span>
                <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentPartnerAccount?.ServiceType"
                       [value]="CurrentPartnerAccount?.ServiceType?.Name || ''"
                       placeholder="{{ 'None' | translate }}" readonly
                       (click)="showPartnerAccountServiceTypeDropdown = !showPartnerAccountServiceTypeDropdown" />
                <i class="material-icons dropdown-clear" *ngIf="CurrentPartnerAccount?.ServiceType" (click)="CurrentPartnerAccount.ServiceType = null; $event.stopPropagation();">close</i>
                <i class="material-icons dropdown-icon" (click)="showPartnerAccountServiceTypeDropdown = !showPartnerAccountServiceTypeDropdown">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showPartnerAccountServiceTypeDropdown">
                <div class="CustomDropdownResult" *ngFor="let t of this.parent.CartMasterData?.ShippingServiceTypes"
                     (click)="CurrentPartnerAccount.ServiceType = t; showPartnerAccountServiceTypeDropdown = false;">
                  {{t.Name}}
                </div>
              </div>
            </div>
          </div>

          <div class="AccountPopUpCommands">
            <button class="GridCommandButton GridCommandButtonGreen" (click)="SavePartnerAccount();">
              <i class="material-icons">save</i>
              <span>{{'SaveButton' | translate}}</span>
            </button>
          </div>
        </div>

        <div class="overlay" *ngIf="ShowPartnerAccountPopUp == true;"></div>
      </div>

      <div *ngIf="ShowAgentsInfo" class="fullWidth" style="height: auto; float: left; padding: 0;">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">people</i>
          {{'AgentsInfo' | translate}}
        </div>

        <div class="ModernFormGroup" *ngIf="this.PartnerAgents?.length > 0;">
          <label class="ModernFormLabel">{{ 'Agents' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownOverlay" *ngIf="showAgentsDropdown" (click)="showAgentsDropdown = false"></div>
            <div class="ModernDropdownBar" [class.open]="showAgentsDropdown" (click)="showAgentsDropdown = !showAgentsDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!this.PartnerAgent">
                {{this.PartnerAgent?.Name || ('SelectAgent' | translate)}}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="showAgentsDropdown">
              <div class="ModernDropdownOption" *ngFor="let p of this.PartnerAgents"
                   [class.selected]="this.PartnerAgent?.ID === p.ID"
                   (click)="this.PartnerAgent = p; showAgentsDropdown = false;">
                <span>{{p.Name}}</span>
                <span class="DefaultPhasesBtnCount" *ngIf="p.OrderPhases?.length > 0"
                      style="margin-left:6px;">{{p.OrderPhases.length}}</span>
                <i class="material-icons check-icon" *ngIf="this.PartnerAgent?.ID === p.ID">check</i>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-bottom: 20px;">
          <button class="ModernActionButton success" (click)="InitializePartnerAgent(this.Partner.ID);">
            <i class="material-icons">person_add</i>
            {{'AddNewAgent' | translate}}
          </button>
        </div>

        <div *ngIf="this.PartnerAgent != null;">
          <!-- Select Notification Phases Button (full width, above shipping) -->
          <div class="ModernFormGroup" *ngIf="PartnerAgent?.ID > 0">
            <button class="DefaultPhasesBtn" (click)="openDefaultPhasesPopup();"
                    [class.has-phases]="PartnerAgent?.OrderPhases?.length > 0">
              <i class="material-icons">tune</i>
              <span>{{ 'SelectNotificationPhases' | translate }}</span>
              <span class="DefaultPhasesBtnCount" *ngIf="PartnerAgent?.OrderPhases?.length > 0">{{PartnerAgent.OrderPhases.length}}</span>
              <i class="material-icons" style="margin-left:auto;font-size:18px;color:#999;">expand_more</i>
            </button>
          </div>

          <div class="ModernFormGroup" *ngIf="this.ShippingAddresses?.length > 0;">
            <label class="ModernFormLabel">{{ 'ShippingAddresses' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showAgentShippingDropdown" (click)="showAgentShippingDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showAgentShippingDropdown" (click)="showAgentShippingDropdown = !showAgentShippingDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!this.PartnerAgent.AllocatedShippingAddress">
                  {{this.PartnerAgent.AllocatedShippingAddress ? (this.PartnerAgent.AllocatedShippingAddress.Country?.Name + ' ' + this.PartnerAgent.AllocatedShippingAddress.City) : ('SelectAddress' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showAgentShippingDropdown">
                <div class="ModernDropdownOption" *ngFor="let a of this.ShippingAddresses"
                     [class.selected]="this.PartnerAgent.AllocatedShippingAddress?.ID === a.ID"
                     (click)="this.PartnerAgent.AllocatedShippingAddress = a; showAgentShippingDropdown = false;">
                  {{a.Country?.Name}} {{a.City}} {{a.AddressLine}}
                  <i class="material-icons check-icon" *ngIf="this.PartnerAgent.AllocatedShippingAddress?.ID === a.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormHalf">
            <div class="ModernFormGroup">
              <label class="ModernFormLabel required">{{ 'Name' | translate }}</label>
              <input type="text" class="ModernFormInput" placeholder="{{ 'Name' | translate }}" autocomplete="off" [(ngModel)]="this.PartnerAgent.Name">
            </div>

            <div class="ModernFormGroup">
              <label class="ModernFormLabel required">{{ 'Phone' | translate }}</label>
              <input type="tel" class="ModernFormInput" placeholder="{{ 'Phone' | translate }}" autocomplete="off" [(ngModel)]="this.PartnerAgent.Phone">
            </div>

            <div class="ModernFormGroup">
              <label class="ModernFormLabel required">{{ 'Email' | translate }}</label>
              <input type="email" class="ModernFormInput" placeholder="{{ 'Email' | translate }}" autocomplete="off" [(ngModel)]="this.PartnerAgent.Email">
            </div>

            <button class="ModernActionButton danger" (click)="ShowPartnerAgentDeleteMessage = true;">
              <i class="material-icons">delete</i>
              {{'DeleteButton' | translate}}
            </button>
          </div>

          <div class="ModernFormHalf">
            <div class="ModernFormGroup" *ngIf="this.Departments?.length > 0;">
              <label class="ModernFormLabel">{{ 'Department' | translate }}</label>
              <div class="ModernDropdownContainer">
                <div class="ModernDropdownOverlay" *ngIf="showDepartmentDropdown" (click)="showDepartmentDropdown = false"></div>
                <div class="ModernDropdownBar" [class.open]="showDepartmentDropdown" (click)="showDepartmentDropdown = !showDepartmentDropdown">
                  <span class="ModernDropdownText" [class.placeholder]="!this.PartnerAgent.Department">
                    {{this.PartnerAgent.Department?.Name || ('SelectDepartment' | translate)}}
                  </span>
                  <i class="material-icons ModernDropdownArrow">expand_more</i>
                </div>
                <div class="ModernDropdownResults" *ngIf="showDepartmentDropdown">
                  <div class="ModernDropdownOption" *ngFor="let d of this.Departments"
                       [class.selected]="this.PartnerAgent.Department?.ID === d.ID"
                       (click)="this.PartnerAgent.Department = d; showDepartmentDropdown = false;">
                    {{d.Name}}
                    <i class="material-icons check-icon" *ngIf="this.PartnerAgent.Department?.ID === d.ID">check</i>
                  </div>
                </div>
              </div>
            </div>

            <button class="ModernActionButton success" *ngIf="PartnerAgent != null;" (click)="AddUpdatePartnerAgent();">
              <i class="material-icons">save</i>
              {{'SaveButton' | translate}}
            </button>
          </div>
        </div>
      </div>

      <!-- Default Agent Phases Popup -->
      <div class="ModernPopupOverlay" *ngIf="showDefaultPhasesPopup">
        <div class="ModernPopup medium animated fadeInDown" style="height: auto; max-height: 80vh;">
          <div class="ModernPopupHeader">
            <div class="ModernPopupTitle">
              <i class="material-icons">tune</i>
              {{ 'SelectNotificationPhases' | translate }} — {{selectedDefaultPhaseAgent?.Name}}
            </div>
            <button class="ModernPopupClose" (click)="closeDefaultPhasesPopup();">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="ModernPopupBody" style="padding: 16px 20px; max-height: 55vh; overflow-y: auto;">
            <p class="NotificationPhasesExplanation">
              <i class="material-icons" style="font-size:14px;vertical-align:middle;margin-right:4px;color:#4a7bb8;">info_outline</i>
              {{ 'NotificationPhasesExplanation' | translate }}
            </p>
            <div class="DefaultPhaseItem" *ngFor="let phase of defaultPhasesMasterData"
                 [class.selected]="isDefaultPhaseSelected(phase)"
                 (click)="toggleDefaultPhase(phase)"
                 (dblclick)="toggleAllDefaultPhases(phase); $event.stopPropagation();">
              <div class="DefaultPhaseItemRow">
                <i class="material-icons DefaultPhaseCheckIcon"
                   [style.color]="isDefaultPhaseSelected(phase) ? '#007aff' : '#ccc'">
                  {{ isDefaultPhaseSelected(phase) ? 'check_circle' : 'radio_button_unchecked' }}
                </i>
                <span class="DefaultPhaseName">{{phase.Name}}</span>
              </div>
              <p class="DefaultPhaseDescription">{{phase.Description}}</p>
            </div>
          </div>
          <div style="padding:12px 20px;border-top:1px solid #d0e0f5;display:flex;justify-content:flex-end;">
            <button class="GridCommandButton primary" (click)="saveDefaultPhases();" [disabled]="savingDefaultPhases">
              <i class="material-icons">save</i>
              {{'SaveButton' | translate}}
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="ShowProfitSettings" class="fullWidth" style="height: auto; float: left; padding: 0;">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">trending_up</i>
          {{'ProfitSettings' | translate}}
          <span style="margin-left: 12px; font-size: 12px; font-weight: 400; color: #5a7a9a;">
            <i class="material-icons" style="font-size: 16px; vertical-align: middle; color: #4a7bb8;" matTooltip="{{ 'ProfitSettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>info</i>
          </span>
        </div>

        <div class="fullWidth">
          <div style="margin-bottom: 16px;">
            <button class="ModernActionButton success" (click)="OpenNewProfitSettings();">
              <i class="material-icons">add</i>
              <span>{{'AddNewProfitSettings' | translate}}</span>
            </button>
          </div>

          <div class="ProfitSettingsTable">
            <div class="ProfitSettingsRow ProfitSettingsHeadder">
              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>#</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;">
                <span>{{'Client' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'DiscountGroup' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'ImportConfiguration' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'Brand' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'Percentage' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 10%;">
                <span>{{'Profit' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>{{'Actions' | translate}}</span>
              </div>
            </div>
  
            <div class="ProfitSettingsRow" *ngFor="let ps of this.Partner?.PartnerProfitSettings; let i=index;">
              <div class="ProfitSettingsCol" style="width: 5%;" (click)="EditProfitSettings(ps);">
                <span>{{i + 1}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;" (click)="EditProfitSettings(ps);">
                <span *ngIf="ps.PartnerName != null && ps.PartnerName?.length > 0;">{{ps.PartnerName}}</span>
                <span *ngIf="ps.PartnerName == null || ps.PartnerName?.length == 0;">-----</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                <span *ngIf="ps.DiscountGroup != null;">{{ps.DiscountGroup?.GroupName}} </span>
                <span *ngIf="ps.DiscountGroup != null;">({{ps.DiscountGroup?.DiscountValue}}%)</span>
                <span *ngIf="ps.DiscountGroup == null;">-----</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                <span *ngIf="ps.ImportConfiguration != null;">{{ps.ImportConfiguration?.Name}}</span>
                <span *ngIf="ps.ImportConfiguration == null;">-----</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                <span *ngIf="ps.Brand != null;">{{ps.Brand?.Name}}</span>
                <span *ngIf="ps.Brand == null;">-----</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                <span *ngIf="ps.Percentage != null;">{{ps.Percentage}}% {{ps.PercentageImpact?.Name}}</span>
                <span *ngIf="ps.Percentage == null;">-----</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 10%;" (click)="EditProfitSettings(ps);">
                <span *ngIf="ps.PercentageImpact != null;">{{ps.PercentageImpact?.PercentageProfitMargin}}%</span>
                <span *ngIf="ps.PercentageImpact == null;">-----</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 5%;" (click)="CopyProfitSettingsUI(ps);">
                <i class="material-icons">content_copy</i>
              </div>
            </div>
  
          </div>
        </div>
       
      </div>

      <div *ngIf="ShowProcessingSettings" class="fullWidth" style="height: auto; float: left; padding: 0;">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">settings</i>
          <span>{{'ProcessingSettings' | translate}}</span>
          <i class="material-icons" style="font-size: 16px; margin-left: 8px; color: #4a7bb8;" matTooltip="{{ 'ProcessingSettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>info</i>
        </div>

        <div class="ModernFormHalf">
          <div class="ModernToggleContainer" matTooltip="{{ 'NotifiesWithAttachmentsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="this.Partner.ProcessingSettings.NotifiesWithAttachments">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'NotifiesWithAttachments' | translate}}</span>
          </div>

          <div class="ModernToggleContainer" matTooltip="{{ 'AutoPrintingDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="this.Partner.ProcessingSettings.AutoPrinting">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'AutoPrinting' | translate}}</span>
          </div>

          <div class="ModernToggleContainer" matTooltip="{{ 'AllocateAutomaticShippingCostDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="this.Partner.ProcessingSettings.AllocateAutomaticShippingCost">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'AllocateAutomaticShippingCost' | translate}}</span>
          </div>

          <div class="ModernToggleContainer" matTooltip="{{ 'GenerateInvoiceDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="this.Partner.ProcessingSettings.GenerateInvoice">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'GenerateInvoice' | translate}}</span>
          </div>

          <div class="ModernToggleContainer" matTooltip="{{ 'GenerateTrackingLabelDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="this.Partner.ProcessingSettings.GenerateTrackingLabel">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'GenerateTrackingLabel' | translate}}</span>
          </div>

          <div class="ModernToggleContainer" matTooltip="{{ 'SeparateOrderInvoicesDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="this.Partner.ProcessingSettings.SeparateOrderInvoices">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'SeparateOrderInvoices' | translate}}</span>
          </div>
        </div>

        <div class="ModernFormHalf">
          <div class="ModernToggleContainer" matTooltip="{{ 'GenerateQWCertificateDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="this.Partner.ProcessingSettings.GenerateQWCertificate">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'GenerateQWCertificate' | translate}}</span>
          </div>

          <div class="ModernToggleContainer" matTooltip="{{ 'PrintOnlyDeliveryNoteDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="this.Partner.ProcessingSettings.PrintOnlyDeliveryNote">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'PrintOnlyDeliveryNote' | translate}}</span>
          </div>

          <div class="ModernToggleContainer" matTooltip="{{ 'SendInvoiceOnlyToAccountingDepartmentDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="this.Partner.ProcessingSettings.SendInvoiceOnlyToAccountingDepartment">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'SendInvoiceOnlyToAccountingDepartment' | translate}}</span>
          </div>

          <div class="ModernToggleContainer" matTooltip="{{ 'SellingPartnerCompanyDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="this.Partner.ProcessingSettings.SellThroughPartnerCompany">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'SellingPartnerCompany' | translate}}</span>
          </div>
        </div>

        <div style="width: 100%; float: left; clear: both; margin-top: 20px;">
          <div class="ModernFormRow">
            <div class="ModernFormGroup" style="width: 30%;" matTooltip="{{ 'ProcessingSettingsCurrencyDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="ModernFormLabel">{{ 'ProcessingSettingsCurrency' | translate }}</label>
              <div class="ModernDropdownContainer">
                <div class="ModernDropdownOverlay" *ngIf="showCurrencyDropdown" (click)="showCurrencyDropdown = false"></div>
                <div class="ModernDropdownBar" [class.open]="showCurrencyDropdown" (click)="showCurrencyDropdown = !showCurrencyDropdown">
                  <span class="ModernDropdownText" [class.placeholder]="!this.Partner.ProcessingSettings?.Currency">
                    {{this.Partner.ProcessingSettings?.Currency?.Name || ('SelectCurrency' | translate)}}
                  </span>
                  <i class="material-icons ModernDropdownArrow">expand_more</i>
                </div>
                <div class="ModernDropdownResults" *ngIf="showCurrencyDropdown">
                  <div class="ModernDropdownOption" *ngFor="let c of this.Currencies"
                       [class.selected]="this.Partner.ProcessingSettings?.Currency?.ID === c.ID"
                       (click)="this.Partner.ProcessingSettings.Currency = c; showCurrencyDropdown = false;">
                    {{c.Name}}
                    <i class="material-icons check-icon" *ngIf="this.Partner.ProcessingSettings?.Currency?.ID === c.ID">check</i>
                  </div>
                </div>
              </div>
            </div>

            <div class="ModernFormGroup" style="width: 30%;">
              <label class="ModernFormLabel">{{ 'DecimalPercision' | translate }}</label>
              <div class="ModernDropdownContainer">
                <div class="ModernDropdownOverlay" *ngIf="showDecimalDropdown" (click)="showDecimalDropdown = false"></div>
                <div class="ModernDropdownBar" [class.open]="showDecimalDropdown" (click)="showDecimalDropdown = !showDecimalDropdown">
                  <span class="ModernDropdownText" [class.placeholder]="!this.Partner.ProcessingSettings?.DecimalPrecision">
                    {{this.Partner.ProcessingSettings?.DecimalPrecision?.Meaning || ('SelectPrecision' | translate)}}
                  </span>
                  <i class="material-icons ModernDropdownArrow">expand_more</i>
                </div>
                <div class="ModernDropdownResults" *ngIf="showDecimalDropdown">
                  <div class="ModernDropdownOption" *ngFor="let d of this.DecimalPrecisions"
                       [class.selected]="this.Partner.ProcessingSettings?.DecimalPrecision?.ID === d.ID"
                       (click)="this.Partner.ProcessingSettings.DecimalPrecision = d; showDecimalDropdown = false;">
                    {{d.Meaning}}
                    <i class="material-icons check-icon" *ngIf="this.Partner.ProcessingSettings?.DecimalPrecision?.ID === d.ID">check</i>
                  </div>
                </div>
              </div>
            </div>

            <div class="ModernFormGroup" style="width: 30%;">
              <label class="ModernFormLabel" style="font-style: italic; color: orange;">{{'UnpaidToleranceDaysLabel' | translate}}</label>
              <input type="number" class="ModernFormInput" [(ngModel)]="this.Partner.ProcessingSettings.UnpaidTolleranceDays" min="0" max="100" step="1">
            </div>
          </div>

          <!-- Grace Blockage Toggle -->
          <div class="GraceBlockageContainer" style="margin-top: 16px; padding: 12px 16px; background: rgba(40, 167, 69, 0.08); border-radius: 8px; border-left: 3px solid #28a745;">
            <div class="ModernToggleContainer" matTooltip="{{ 'GraceBlockageDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="ModernToggle">
                <input type="checkbox" [(ngModel)]="this.Partner.ProcessingSettings.GraceBlockage">
                <span class="ModernToggleSlider"></span>
              </label>
              <span class="ModernToggleLabel" style="font-weight: 600; color: #28a745;">{{'GraceBlockage' | translate}}</span>
            </div>
            <p style="margin: 8px 0 0 0; font-size: 12px; font-style: italic; color: #6c757d;">{{'GraceBlockageHint' | translate}}</p>
          </div>

          <!-- Email Attachment Type Dropdown -->
          <div class="ModernFormGroup" style="width: 50%; margin-top: 16px;">
            <label class="ModernFormLabel">{{'EmailAttachmentType' | translate}}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showEmailAttachmentTypeDropdown" (click)="showEmailAttachmentTypeDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showEmailAttachmentTypeDropdown" (click)="showEmailAttachmentTypeDropdown = !showEmailAttachmentTypeDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!this.Partner.ProcessingSettings?.EmailAttachmentType">
                  {{this.Partner.ProcessingSettings?.EmailAttachmentType?.Name || ('SelectEmailAttachmentType' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showEmailAttachmentTypeDropdown">
                <div class="ModernDropdownOption" *ngFor="let t of this.FileExportTypes"
                     [class.selected]="this.Partner.ProcessingSettings?.EmailAttachmentType?.ID === t.ID"
                     (click)="this.Partner.ProcessingSettings.EmailAttachmentType = t; showEmailAttachmentTypeDropdown = false;">
                  {{t.Name}}
                  <i class="material-icons check-icon" *ngIf="this.Partner.ProcessingSettings?.EmailAttachmentType?.ID === t.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <!-- Send Each File To The Appropriate Department Toggle -->
          <div class="ModernToggleContainer" style="margin-top: 16px;" matTooltip="{{ 'SendEachFileToTheAppropriateDepartmentDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="this.Partner.ProcessingSettings.SendEachFileToTheAppropriateDepartment">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'SendEachFileToTheAppropriateDepartment' | translate}}</span>
          </div>

          <div class="ModernFormGroup" *ngIf="this.Partner.ProcessingSettings?.SellThroughPartnerCompany == true;" style="width: 50%; margin-top: 16px;">
            <label class="ModernFormLabel">{{ 'ChooseSellingPartnerCompany' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showPartnerCompanyDropdown" (click)="showPartnerCompanyDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showPartnerCompanyDropdown" (click)="showPartnerCompanyDropdown = !showPartnerCompanyDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!this.Partner.ProcessingSettings?.PartnerCompany">
                  {{this.Partner.ProcessingSettings?.PartnerCompany?.Name || ('SelectCompany' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showPartnerCompanyDropdown">
                <div class="ModernDropdownOption" *ngFor="let c of this.Companies"
                     [class.selected]="this.Partner.ProcessingSettings?.PartnerCompany?.ID === c.ID"
                     (click)="this.Partner.ProcessingSettings.PartnerCompany = c; showPartnerCompanyDropdown = false;">
                  {{c.Name}}
                  <i class="material-icons check-icon" *ngIf="this.Partner.ProcessingSettings?.PartnerCompany?.ID === c.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <!-- Items Grouping Settings Section -->
          <div class="ModernFormSubtitle" style="margin-top: 32px; margin-bottom: 16px;">
            <i class="material-icons" style="font-size: 18px; margin-right: 8px; vertical-align: middle;">layers</i>
            {{'ItemsGroupingSettings' | translate}}
            <i class="material-icons" style="font-size: 16px; margin-left: 8px; color: #4a7bb8;" matTooltip="{{ 'ItemsGroupingSettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>info</i>
          </div>

          <div class="ModernFormHalf">
            <div class="ModernToggleContainer" matTooltip="{{ 'GroupByShippingServiceTypeDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="ModernToggle">
                <input type="checkbox" [(ngModel)]="this.Partner.GroupingSettings.GroupByShippingServiceType">
                <span class="ModernToggleSlider"></span>
              </label>
              <span class="ModernToggleLabel">{{'GroupByShippingServiceType' | translate}}</span>
            </div>

            <div class="ModernToggleContainer" matTooltip="{{ 'GroupByShippingAddressDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="ModernToggle">
                <input type="checkbox" [(ngModel)]="this.Partner.GroupingSettings.GroupByShippingAddress">
                <span class="ModernToggleSlider"></span>
              </label>
              <span class="ModernToggleLabel">{{'GroupByShippingAddress' | translate}}</span>
            </div>

            <div class="ModernToggleContainer" matTooltip="{{ 'GroupByShippingCompanyDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="ModernToggle">
                <input type="checkbox" [(ngModel)]="this.Partner.GroupingSettings.GroupByShippingCompany">
                <span class="ModernToggleSlider"></span>
              </label>
              <span class="ModernToggleLabel">{{'GroupByShippingCompany' | translate}}</span>
            </div>
          </div>

          <div class="ModernFormHalf">
            <div class="ModernToggleContainer" matTooltip="{{ 'GroupByCurrencyDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="ModernToggle">
                <input type="checkbox" [(ngModel)]="this.Partner.GroupingSettings.GroupByCurrency">
                <span class="ModernToggleSlider"></span>
              </label>
              <span class="ModernToggleLabel">{{'GroupByCurrency' | translate}}</span>
            </div>

            <div class="ModernToggleContainer" matTooltip="{{ 'GroupByInvoicingCompanyDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="ModernToggle">
                <input type="checkbox" [(ngModel)]="this.Partner.GroupingSettings.GroupByInvoicingCompany">
                <span class="ModernToggleSlider"></span>
              </label>
              <span class="ModernToggleLabel">{{'GroupByInvoicingCompany' | translate}}</span>
            </div>
          </div>

          <!-- Insurance Policy Settings Section -->
          <div style="clear: both; width: 100%; float: left; margin-top: 32px;" *ngIf="this.Partner.InsurancePolicy">
            <div class="ModernFormSubtitle" style="margin-bottom: 16px;">
              <i class="material-icons" style="font-size: 18px; margin-right: 8px; vertical-align: middle;">verified_user</i>
              {{'InsurancePolicySettings' | translate}}
              <i class="material-icons" style="font-size: 16px; margin-left: 8px; color: #4a7bb8;" matTooltip="{{ 'InsurancePolicySettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>info</i>
            </div>

            <div style="width: 100%; float: left; margin-bottom: 16px;">
              <div class="ModernToggleContainer" matTooltip="{{ 'HasInsuranceDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
                <label class="ModernToggle">
                  <input type="checkbox" [(ngModel)]="this.Partner.InsurancePolicy.HasInsurance">
                  <span class="ModernToggleSlider"></span>
                </label>
                <span class="ModernToggleLabel">{{'HasInsurance' | translate}}</span>
              </div>
            </div>

            <div class="ModernFormHalf">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{'InsuranceValue' | translate}}</label>
                <input type="number" class="ModernFormInput" [(ngModel)]="this.Partner.InsurancePolicy.InsuranceValue"
                       step="0.01" min="0" max="100"
                       matTooltip="{{ 'InsuranceValueDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
                <span class="ModernFormHint" style="font-style: italic;">{{'InsuranceValueHint' | translate}}</span>
              </div>
            </div>

            <div class="ModernFormHalf">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{'InsuranceDictator' | translate}}</label>
                <div class="ModernDropdownContainer">
                  <div class="ModernDropdownOverlay" *ngIf="showInsuranceDictatorDropdown" (click)="showInsuranceDictatorDropdown = false"></div>
                  <div class="ModernDropdownBar" [class.open]="showInsuranceDictatorDropdown" (click)="showInsuranceDictatorDropdown = !showInsuranceDictatorDropdown">
                    <span class="ModernDropdownText" [class.placeholder]="!this.Partner.InsurancePolicy?.Dictator">
                      {{this.Partner.InsurancePolicy?.Dictator?.Name ? (this.Partner.InsurancePolicy.Dictator.Name | translate) : ('SelectDictator' | translate)}}
                    </span>
                    <i class="material-icons ModernDropdownArrow">expand_more</i>
                  </div>
                  <div class="ModernDropdownResults" *ngIf="showInsuranceDictatorDropdown">
                    <div class="ModernDropdownOption" *ngFor="let d of this.InsurancePolicyDictators"
                         [class.selected]="this.Partner.InsurancePolicy?.Dictator?.ID === d.ID"
                         (click)="this.Partner.InsurancePolicy.Dictator = d; showInsuranceDictatorDropdown = false;">
                      {{d.Name | translate}}
                      <i class="material-icons check-icon" *ngIf="this.Partner.InsurancePolicy?.Dictator?.ID === d.ID">check</i>
                    </div>
                  </div>
                </div>
                <span class="ModernFormHint" style="font-style: italic;">{{'InsuranceDictatorDesc' | translate}}</span>
              </div>
            </div>

            <div class="ModernFormHalf">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{'InsuranceIllustrator' | translate}}</label>
                <div class="ModernDropdownContainer">
                  <div class="ModernDropdownOverlay" *ngIf="showInsuranceIllustratorDropdown" (click)="showInsuranceIllustratorDropdown = false"></div>
                  <div class="ModernDropdownBar" [class.open]="showInsuranceIllustratorDropdown" (click)="showInsuranceIllustratorDropdown = !showInsuranceIllustratorDropdown">
                    <span class="ModernDropdownText" [class.placeholder]="!this.Partner.InsurancePolicy?.Illustrator">
                      {{this.Partner.InsurancePolicy?.Illustrator?.Name ? (this.Partner.InsurancePolicy.Illustrator.Name | translate) : ('SelectIllustrator' | translate)}}
                    </span>
                    <i class="material-icons ModernDropdownArrow">expand_more</i>
                  </div>
                  <div class="ModernDropdownResults" *ngIf="showInsuranceIllustratorDropdown">
                    <div class="ModernDropdownOption" *ngFor="let i of this.InsurancePolicyIllustrators"
                         [class.selected]="this.Partner.InsurancePolicy?.Illustrator?.ID === i.ID"
                         (click)="this.Partner.InsurancePolicy.Illustrator = i; showInsuranceIllustratorDropdown = false;">
                      {{i.Name | translate}}
                      <i class="material-icons check-icon" *ngIf="this.Partner.InsurancePolicy?.Illustrator?.ID === i.ID">check</i>
                    </div>
                  </div>
                </div>
                <span class="ModernFormHint" style="font-style: italic;">{{'InsuranceIllustratorDesc' | translate}}</span>
              </div>
            </div>
          </div>

          <div style="margin-top: 24px; clear: both;">
            <button class="ModernActionButton primary" (click)="SaveAllProcessingSettings();">
              <i class="material-icons">save</i>
              {{'SaveProcessingSettings' | translate}}
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="ShowB2BRestrictions" class="fullWidth" style="height: auto; float: left; padding: 0;">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">security</i>
          <span>{{'B2BSettingsAndRestrictions' | translate}}</span>
          <i class="material-icons" style="font-size: 16px; margin-left: 8px; color: #4a7bb8;" matTooltip="{{ 'B2BRestrictionsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>info</i>
        </div>

        <div class="ModernFormSubtitle">
          {{'B2BSettings' | translate}}
        </div>

        <div class="ModernFormGroup" style="width: 50%;">
          <label class="ModernFormLabel">{{ 'B2BPartnerCategory' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownOverlay" *ngIf="showB2BCategoryDropdown" (click)="showB2BCategoryDropdown = false"></div>
            <div class="ModernDropdownBar" [class.open]="showB2BCategoryDropdown" (click)="showB2BCategoryDropdown = !showB2BCategoryDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!this.Partner.B2BSettings?.B2BPartnerCategory">
                {{this.Partner.B2BSettings?.B2BPartnerCategory?.Name || ('SelectCategory' | translate)}}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="showB2BCategoryDropdown">
              <div class="ModernDropdownOption" *ngFor="let c of this.B2BPartnerCategories"
                   [class.selected]="this.Partner.B2BSettings?.B2BPartnerCategory?.ID === c.ID"
                   (click)="this.Partner.B2BSettings.B2BPartnerCategory = c; showB2BCategoryDropdown = false;"
                   matTooltip="{{c.Description}}" matTooltipClass='neutral-tool-tip-management'>
                {{c.Name}}
                <i class="material-icons check-icon" *ngIf="this.Partner.B2BSettings?.B2BPartnerCategory?.ID === c.ID">check</i>
              </div>
            </div>
          </div>
        </div>

        <div class="fullWidth" *ngIf="this.Partner.B2BSettings != null;" style="margin-top: 20px;">
          <div class="ModernFormRow">
            <div class="ModernToggleContainer">
              <label class="ModernToggle">
                <input type="checkbox" [(ngModel)]="this.Partner.B2BSettings.PrioritizePriceHistory">
                <span class="ModernToggleSlider"></span>
              </label>
              <span class="ModernToggleLabel">{{'ClientHistoryPricePriority' | translate}}</span>
            </div>

            <div class="ModernToggleContainer">
              <label class="ModernToggle">
                <input type="checkbox" [(ngModel)]="this.Partner.B2BSettings.CanDownloadPriceLists">
                <span class="ModernToggleSlider"></span>
              </label>
              <span class="ModernToggleLabel">{{'CanDownloadPriceLists' | translate}}</span>
            </div>

            <div class="ModernToggleContainer">
              <label class="ModernToggle">
                <input type="checkbox" [(ngModel)]="this.Partner.B2BSettings.Blocked">
                <span class="ModernToggleSlider"></span>
              </label>
              <span class="ModernToggleLabel">{{'Blocked' | translate}}</span>
            </div>
          </div>

          <div class="ModernFormSubtitle" style="margin-top: 20px;">
            {{'APIRateLimitSettings' | translate}}
          </div>

          <div class="ModernFormRow" style="margin-top: 12px;">
            <div class="ModernFormGroup" style="width: 25%; margin-right: 16px;">
              <label class="ModernFormLabel">{{ 'APICallsMinutesWindow' | translate }}</label>
              <input class="ModernFormInput" type="number" min="1" max="60"
                     [(ngModel)]="this.Partner.B2BSettings.APICallsMinutesWindow"
                     placeholder="10">
              <span class="ModernFormHint">{{'APICallsMinutesWindowHint' | translate}}</span>
            </div>

            <div class="ModernFormGroup" style="width: 25%; margin-right: 16px;">
              <label class="ModernFormLabel">{{ 'APIMaxAllowedCalls' | translate }}</label>
              <input class="ModernFormInput" type="number" min="1" max="10000"
                     [(ngModel)]="this.Partner.B2BSettings.APIMaxAllowedCalls"
                     placeholder="100">
              <span class="ModernFormHint">{{'APIMaxAllowedCallsHint' | translate}}</span>
            </div>

            <div class="ModernFormGroup" style="width: 25%;">
              <label class="ModernFormLabel">{{ 'MaxItemsPerApiCall' | translate }}</label>
              <input class="ModernFormInput" type="number" min="1" max="100"
                     [(ngModel)]="this.Partner.B2BSettings.MaxItemsPerApiCall"
                     placeholder="10">
              <span class="ModernFormHint">{{'MaxItemsPerApiCallHint' | translate}}</span>
            </div>
          </div>

          <div class="ModernFormRow" style="margin-top: 16px;">
            <div class="ModernFormGroup" style="width: 100%;">
              <mat-checkbox [(ngModel)]="this.Partner.B2BSettings.IncludeMasterData"
                            [title]="'IncludeMasterDataHint' | translate">
                {{ 'IncludeMasterData' | translate }} - <span style="font-weight: normal; opacity: 0.8;">{{'IncludeMasterDataHint' | translate}}</span>
              </mat-checkbox>
            </div>
          </div>

          <div style="margin-top: 16px;">
            <button class="ModernActionButton success" (click)="AddUpdatePartnerB2BSettings(this.Partner);">
              <i class="material-icons">save</i>
              {{'SaveButton' | translate}}
            </button>
          </div>
        </div>

        <!-- B2B User Settings Section -->
        <div class="B2BUserSettingsSection">
          <div class="B2BUserSettingsSectionHeader">
            <i class="material-icons">person</i>
            {{'B2BUserSettings' | translate}}
          </div>

          <div class="B2BUserSettingsSectionBody">
            <div class="fullWidth" *ngIf="loadingB2BUserSettings" style="padding: 20px; text-align: center;">
              <i class="material-icons rotating">sync</i>
              <span style="margin-left: 8px;">{{'Loading' | translate}}</span>
            </div>

            <div class="fullWidth" *ngIf="!loadingB2BUserSettings && !B2BConnectedUser?.Id" style="padding: 16px; background: #fff3cd; border-radius: 8px;">
              <i class="material-icons" style="color: #856404; vertical-align: middle;">info</i>
              <span style="color: #856404; margin-left: 8px;">{{'NoB2BUserConnectedToPartner' | translate}}</span>
            </div>

            <div class="fullWidth" *ngIf="!loadingB2BUserSettings && B2BConnectedUser?.Id">
              <!-- Connected User Info -->
              <div class="ModernFormGroup" style="width: 50%; margin-bottom: 16px;">
                <label class="ModernFormLabel">{{'B2BConnectedUser' | translate}}</label>
                <div class="ModernFormStaticValue">
                  <i class="material-icons" style="font-size: 18px; vertical-align: middle; margin-right: 8px; color: #4a7bb8;">account_circle</i>
                  <span>{{B2BConnectedUser?.UserName || B2BConnectedUser?.Email}}</span>
                </div>
              </div>

              <!-- B2B Agent Selection -->
              <div class="ModernFormRow" style="align-items: center; margin-bottom: 16px;">
                <span class="ModernFormLabel" style="width: auto; margin-right: 16px;">{{'B2BConnectedAgent' | translate}}:</span>

                <button class="ModernActionButton primary" (click)="OpenB2BAgentSelectContainer();" *ngIf="!B2BConnectedAgent?.ID">
                  <i class="material-icons">account_circle</i>
                  {{'ChooseAgent' | translate}}
                </button>

                <button class="ModernActionButton primary" (click)="OpenB2BAgentSelectContainer();" *ngIf="B2BConnectedAgent?.ID > 0">
                  <i class="material-icons">account_circle</i>
                  {{B2BConnectedAgent?.Name}}
                </button>

                <i class="material-icons" style="cursor: pointer; color: #dc3545; margin-left: 8px;"
                   *ngIf="B2BConnectedAgent?.ID > 0"
                   (click)="PrepareB2BAgentDeallocation();"
                   matTooltip="{{'RemoveAgent' | translate}}" matTooltipClass='neutral-tool-tip-management'>close</i>
              </div>

              <!-- B2B App Access Toggle -->
              <div class="ModernFormRow" style="margin-bottom: 16px;">
                <div class="ModernToggleContainer">
                  <label class="ModernToggle">
                    <input type="checkbox" [checked]="UserHasB2BAppAccess" (change)="ToggleB2BAppAccess(!UserHasB2BAppAccess)">
                    <span class="ModernToggleSlider"></span>
                  </label>
                  <span class="ModernToggleLabel">{{'B2BAppAccess' | translate}}</span>
                  <i class="material-icons" style="font-size: 16px; margin-left: 8px; color: #4a7bb8;"
                     matTooltip="{{ 'B2BAppAccessHint' | translate }}" matTooltipClass='neutral-tool-tip-management'>info</i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End B2B User Settings Section -->

        <div class="fullWidth" style="margin-top: 20px; margin-bottom: 20px;">
          <div class="ProfitSettingsTable">
            <div class="ProfitSettingsRow ProfitSettingsHeadder">
              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>#</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;">
                <span style="font-size: 10px;">{{'Client' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 7.5%;">
                <span>{{'YearsBehind' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 7.5%;">
                <span>{{'YearsBehindTargetYear' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>{{'ExtraAddedPercentageValue' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 20%;">
                <span>{{'Brand' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 10%;">
                <span>{{'OnlyPerosnalHistory' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 10%;">
                <span>{{'CompareHistoryPriceWithListPrice' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'Actions' | translate}}</span>
              </div>
            </div>
  
            <div class="ProfitSettingsRow" *ngFor="let setting of this.Partner?.B2BSettings?.YearSettings; let i=index;">
              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>{{i + 1}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;">
                <span style="font-size: 10px;">{{this.Partner.Name}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 7.5%;">
                <input class="ModernFormInput" type="text" style="width: 90%; height: 28px; font-size: 10px;"
                       placeholder="{{'YearsBehind' | translate}}"
                       (keypress)="restrictNonNumericInput($event)"
                       (change)="onYearsBehindChange($event)"
                       [(ngModel)]="setting.YearsBehind"
                       maxlength="5">
              </div>

              <div class="ProfitSettingsCol" style="width: 7.5%;">
                <span>{{setting.YearsBehindTargetYear}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 5%;" >
                <input class="ModernFormInput" type="text" style="width: 90%; height: 28px; font-size: 10px;"
                       placeholder="%"
                       [(ngModel)]="this.setting.ExtraAddedPercentageValue"
                       maxlength="5">
              </div>

              <div class="ProfitSettingsCol" style="width: 20%;" (click)="this.CurrentYearSetting = setting; OpenYearSettingsBrandChange();">
                <span *ngIf="setting?.Brand?.ID > 0">{{setting?.Brand?.Name}}</span>
                <span *ngIf="!(setting?.Brand?.ID > 0)">-------------</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 10%;">
                <label class="ModernToggle compact">
                  <input type="checkbox" [(ngModel)]="setting.OnlyPerosnalHistory">
                  <span class="ModernToggleSlider"></span>
                </label>
              </div>

              <div class="ProfitSettingsCol" style="width: 10%;">
                <label class="ModernToggle compact">
                  <input type="checkbox" [(ngModel)]="setting.CompareHistoryPriceWithListPrice">
                  <span class="ModernToggleSlider"></span>
                </label>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%; gap: 8px;">
                <i class="material-icons RestrictionIcon success" (click)="AddUpdateHistoryYearSetting(setting);">check</i>
                <i class="material-icons RestrictionIcon danger" (click)="PrepareYearSettingsDelete(setting);">close</i>
              </div>
            </div>

            <div class="ProfitSettingsRow">
              <div class="ProfitSettingsCol" style="width: 5%;">
                <div class="AddYearSettingsButton" (click)="InitializeNewYearsSettings();" *ngIf="this.NewYearSettings?.DBID != 0;">
                  <i class="material-icons">add</i>
                </div>
              </div>

              <div class="ProfitSettingsCol" style="width: 20%;" *ngIf="this.NewYearSettings?.DBID == 0;">
                <span style="font-size: 10px;">{{this.Partner.Name}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 7.5%;" *ngIf="this.NewYearSettings?.DBID == 0;">
                <input class="ModernFormInput" type="text" style="width: 90%; height: 28px; font-size: 10px;"
                       placeholder="{{'YearsBehind' | translate}}"
                       (keypress)="restrictNonNumericInput($event)"
                       (change)="onYearsBehindChange($event)"
                       [(ngModel)]="this.NewYearSettings.YearsBehind"
                       maxlength="5">
              </div>

              <div class="ProfitSettingsCol" style="width: 7.5%;" *ngIf="this.NewYearSettings?.DBID == 0;">
                <span>{{this.NewYearSettings.YearsBehindTargetYear}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 5%;" *ngIf="this.NewYearSettings?.DBID == 0;">
                <input class="ModernFormInput" type="text" style="width: 90%; height: 28px; font-size: 10px;"
                       placeholder="%"
                       [(ngModel)]="this.NewYearSettings.ExtraAddedPercentageValue"
                       maxlength="5">
              </div>

              <div class="ProfitSettingsCol" style="width: 20%;" *ngIf="this.NewYearSettings?.DBID == 0;" (click)="OpenNewYearSettingsBrandChange();">
                <span *ngIf="this.NewYearSettings?.Brand?.ID > 0">{{this.NewYearSettings?.Brand?.Name}}</span>
                <span *ngIf="!(this.NewYearSettings?.Brand?.ID > 0)">-------------</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 10%;" *ngIf="this.NewYearSettings?.DBID == 0;">
                <label class="ModernToggle compact">
                  <input type="checkbox" [(ngModel)]="NewYearSettings.OnlyPerosnalHistory">
                  <span class="ModernToggleSlider"></span>
                </label>
              </div>

              <div class="ProfitSettingsCol" style="width: 10%;" *ngIf="this.NewYearSettings?.DBID == 0;">
                <label class="ModernToggle compact">
                  <input type="checkbox" [(ngModel)]="NewYearSettings.CompareHistoryPriceWithListPrice">
                  <span class="ModernToggleSlider"></span>
                </label>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%; gap: 8px;" *ngIf="this.NewYearSettings?.DBID == 0;">
                <i class="material-icons RestrictionIcon success" (click)="AddUpdateHistoryYearSetting(this.NewYearSettings);">check</i>
                <i class="material-icons RestrictionIcon danger" (click)="this.NewYearSettings = null;">close</i>
              </div>
            </div>
  
          </div>
        </div>

        <div class="ModernFormDivider"></div>

        <div class="ModernFormSubtitle">
          {{'B2BRestrictions' | translate}}
        </div>

        <div class="fullWidth">
          <div style="margin-bottom: 16px;">
            <button class="ModernActionButton success" (click)="InitializeNewRestriction(this.Partner);">
              <i class="material-icons">add</i>
              {{'NewB2BRestrictions' | translate}}
            </button>
          </div>

          <div class="ProfitSettingsTable">
            <div class="ProfitSettingsRow ProfitSettingsHeadder">
              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>#</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;">
                <span>{{'Client' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'RestrictionType' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'ImportConfiguration' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;">
                <span>{{'Brand' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 10%;">
                <span>{{'Country' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'Actions' | translate}}</span>
              </div>
            </div>
  
            <div class="ProfitSettingsRow" *ngFor="let res of this.Partner?.B2BRestrictions; let i=index;">
              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>{{i + 1}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;">
                <span>{{this.Partner.Name}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{res.Type.Name}} </span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span *ngIf="res.RestrictedConfiguration != null;">{{res.RestrictedConfiguration?.Name}}</span>
                <span *ngIf="res.RestrictedConfiguration == null;">-----</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;" >
                <span *ngIf="res.RestrictedBrand != null;">{{res.RestrictedBrand?.Name}}</span>
                <span *ngIf="res.RestrictedBrand == null;">-----</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 10%;">
                <span *ngIf="res.RestrictedCountry != null;">{{res.RestrictedCountry?.Name}}</span>
                <span *ngIf="res.RestrictedCountry == null;">-----</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <i class="material-icons RestrictionIcon danger" (click)="PrepareRestrictionDelete(res);">close</i>
              </div>
            </div>
  
          </div>
        </div>
      </div>

      <!-- Contractual Conditions Tab -->
      <div *ngIf="ShowContractualConditions" class="fullWidth" style="height: auto; float: left; padding: 0;">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">description</i>
          <span>{{'ContractualConditions' | translate}}</span>
          <i class="material-icons" style="font-size: 16px; margin-left: 8px; color: #4a7bb8;" matTooltip="{{ 'ContractualConditionsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>info</i>
        </div>

        <div class="ModernFormRow">
          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'BuyPaymentTerms' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showBuyPaymentTermsDropdown" (click)="showBuyPaymentTermsDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showBuyPaymentTermsDropdown" (click)="showBuyPaymentTermsDropdown = !showBuyPaymentTermsDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!ContractualConditions?.BuyPaymentTerms">
                  {{ContractualConditions?.BuyPaymentTerms?.Name || ('SelectPaymentTerm' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showBuyPaymentTermsDropdown">
                <div class="ModernDropdownOption" *ngFor="let pt of PaymentTerms"
                     [class.selected]="ContractualConditions?.BuyPaymentTerms?.ID === pt.ID"
                     (click)="ContractualConditions.BuyPaymentTerms = pt; showBuyPaymentTermsDropdown = false;">
                  {{pt.Name}}
                  <i class="material-icons check-icon" *ngIf="ContractualConditions?.BuyPaymentTerms?.ID === pt.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'SellPaymentTerms' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showSellPaymentTermsDropdown" (click)="showSellPaymentTermsDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showSellPaymentTermsDropdown" (click)="showSellPaymentTermsDropdown = !showSellPaymentTermsDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!ContractualConditions?.SellPaymentTerms">
                  {{ContractualConditions?.SellPaymentTerms?.Name || ('SelectPaymentTerm' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showSellPaymentTermsDropdown">
                <div class="ModernDropdownOption" *ngFor="let pt of PaymentTerms"
                     [class.selected]="ContractualConditions?.SellPaymentTerms?.ID === pt.ID"
                     (click)="ContractualConditions.SellPaymentTerms = pt; showSellPaymentTermsDropdown = false;">
                  {{pt.Name}}
                  <i class="material-icons check-icon" *ngIf="ContractualConditions?.SellPaymentTerms?.ID === pt.ID">check</i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- New Row: Shipping Company & Shipping Responsability -->
        <div class="ModernFormRow">
          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'ShippingResponsability' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showContractualShippingResponsabilityDropdown" (click)="showContractualShippingResponsabilityDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showContractualShippingResponsabilityDropdown" (click)="showContractualShippingResponsabilityDropdown = !showContractualShippingResponsabilityDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!ContractualConditions?.ShippingResponsability">
                  {{ContractualConditions?.ShippingResponsability?.Name || ('SelectShippingResponsability' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showContractualShippingResponsabilityDropdown">
                <div class="ModernDropdownOption" *ngFor="let sr of parent.CartMasterData?.ShippingResponsabilities"
                     [class.selected]="ContractualConditions?.ShippingResponsability?.ID === sr.ID"
                     (click)="selectContractualShippingResponsability(sr);">
                  {{sr.Name}}
                  <i class="material-icons check-icon" *ngIf="ContractualConditions?.ShippingResponsability?.ID === sr.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'ShippingCompany' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showContractualShippingCompanyDropdown" (click)="showContractualShippingCompanyDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showContractualShippingCompanyDropdown" (click)="showContractualShippingCompanyDropdown = !showContractualShippingCompanyDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!ContractualConditions?.ShippingCompany">
                  {{ContractualConditions?.ShippingCompany?.Name || ('SelectShippingCompany' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showContractualShippingCompanyDropdown">
                <div class="ModernDropdownOption" *ngFor="let sc of parent.CartMasterData?.ShippingCompanies"
                     [class.selected]="ContractualConditions?.ShippingCompany?.ID === sc.ID"
                     (click)="ContractualConditions.ShippingCompany = sc; showContractualShippingCompanyDropdown = false;">
                  {{sc.Name}}
                  <i class="material-icons check-icon" *ngIf="ContractualConditions?.ShippingCompany?.ID === sc.ID">check</i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Use Partner Carrier Account Toggle (only visible for EXW shipping responsibility) -->
        <div class="ModernFormRow" *ngIf="ContractualConditions?.ShippingResponsability?.ID == 0">
          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="ContractualConditions.UsePartnerCarrierAccount">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'UsePartnerCarrierAccount' | translate}}</span>
          </div>
        </div>

        <!-- New Row: Payment Type & Shipping Service Type -->
        <div class="ModernFormRow">
          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'PaymentType' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showContractualPaymentTypeDropdown" (click)="showContractualPaymentTypeDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showContractualPaymentTypeDropdown" (click)="showContractualPaymentTypeDropdown = !showContractualPaymentTypeDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!ContractualConditions?.PaymentType">
                  {{ContractualConditions?.PaymentType?.Name || ('SelectPaymentType' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showContractualPaymentTypeDropdown">
                <div class="ModernDropdownOption" *ngFor="let ptype of parent.CartMasterData?.PaymentTypes"
                     [class.selected]="ContractualConditions?.PaymentType?.ID === ptype.ID"
                     (click)="ContractualConditions.PaymentType = ptype; showContractualPaymentTypeDropdown = false;">
                  {{ptype.Name}}
                  <i class="material-icons check-icon" *ngIf="ContractualConditions?.PaymentType?.ID === ptype.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'ShippingServiceType' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showContractualShippingServiceTypeDropdown" (click)="showContractualShippingServiceTypeDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showContractualShippingServiceTypeDropdown" (click)="showContractualShippingServiceTypeDropdown = !showContractualShippingServiceTypeDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!ContractualConditions?.ShippingServiceType">
                  {{ContractualConditions?.ShippingServiceType?.Name || ('SelectShippingServiceType' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showContractualShippingServiceTypeDropdown">
                <div class="ModernDropdownOption" *ngFor="let sst of parent.CartMasterData?.ShippingServiceTypes"
                     [class.selected]="ContractualConditions?.ShippingServiceType?.ID === sst.ID"
                     (click)="ContractualConditions.ShippingServiceType = sst; showContractualShippingServiceTypeDropdown = false;">
                  {{sst.Name}}
                  <i class="material-icons check-icon" *ngIf="ContractualConditions?.ShippingServiceType?.ID === sst.ID">check</i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- New Row: Consolidation Type & Delivery Preference -->
        <div class="ModernFormRow">
          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'ConsolidationType' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showContractualConsolidationTypeDropdown" (click)="showContractualConsolidationTypeDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showContractualConsolidationTypeDropdown" (click)="showContractualConsolidationTypeDropdown = !showContractualConsolidationTypeDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!ContractualConditions?.ConsolidationType">
                  {{ContractualConditions?.ConsolidationType?.Name || ('SelectConsolidationType' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showContractualConsolidationTypeDropdown">
                <div class="ModernDropdownOption" *ngFor="let ct of parent.CartMasterData?.ConsolidationTypes"
                     [class.selected]="ContractualConditions?.ConsolidationType?.ID === ct.ID"
                     (click)="ContractualConditions.ConsolidationType = ct; showContractualConsolidationTypeDropdown = false;">
                  {{ct.Name}}
                  <i class="material-icons check-icon" *ngIf="ContractualConditions?.ConsolidationType?.ID === ct.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'DeliveryPreference' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showContractualDeliveryPreferenceDropdown" (click)="showContractualDeliveryPreferenceDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showContractualDeliveryPreferenceDropdown" (click)="showContractualDeliveryPreferenceDropdown = !showContractualDeliveryPreferenceDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!ContractualConditions?.DeliveryPreference">
                  {{ContractualConditions?.DeliveryPreference?.Name || ('SelectDeliveryPreference' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showContractualDeliveryPreferenceDropdown">
                <div class="ModernDropdownOption" *ngFor="let dp of parent.CartMasterData?.DeliveryPreferences"
                     [class.selected]="ContractualConditions?.DeliveryPreference?.ID === dp.ID"
                     (click)="ContractualConditions.DeliveryPreference = dp; showContractualDeliveryPreferenceDropdown = false;">
                  {{dp.Name}}
                  <i class="material-icons check-icon" *ngIf="ContractualConditions?.DeliveryPreference?.ID === dp.ID">check</i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Account Type -->
        <div class="ModernFormRow">
          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'AccountType' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showContractualAccountTypeDropdown" (click)="showContractualAccountTypeDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showContractualAccountTypeDropdown" (click)="showContractualAccountTypeDropdown = !showContractualAccountTypeDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!ContractualConditions?.AccountType">
                  {{ContractualConditions?.AccountType?.Name || ('SelectAccountType' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showContractualAccountTypeDropdown">
                <div class="ModernDropdownOption" *ngFor="let at of PartnerAccountTypes"
                     [class.selected]="ContractualConditions?.AccountType?.ID === at.ID"
                     (click)="ContractualConditions.AccountType = at; showContractualAccountTypeDropdown = false;">
                  {{at.Name}}
                  <span *ngIf="at.Description" style="color: #86868b; font-weight: 400; font-size: 11px;"> ({{at.Description}})</span>
                  <i class="material-icons check-icon" *ngIf="ContractualConditions?.AccountType?.ID === at.ID">check</i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ModernFormDivider"></div>

        <div class="ModernFormRow">
          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="ContractualConditions.HasContract">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'HasContract' | translate}}</span>
          </div>

          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="ContractualConditions.RequiresContract">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'RequiresContract' | translate}}</span>
          </div>

          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="ContractualConditions.SignedByOurCompany">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'SignedByOurCompany' | translate}}</span>
          </div>
        </div>

        <div class="ModernFormRow" style="margin-top: 16px;">
          <div class="ModernFormGroup" style="width: 33%;">
            <label class="ModernFormLabel">{{ 'ContractSignedDate' | translate }}</label>
            <input class="ModernFormInput" type="date" [(ngModel)]="ContractualConditions.ContractSignedDate">
          </div>

          <div class="ModernFormGroup" style="width: 33%;">
            <label class="ModernFormLabel">{{ 'ContractExpirationDate' | translate }}</label>
            <input class="ModernFormInput" type="date" [(ngModel)]="ContractualConditions.ContractExpirationDate">
          </div>

          <div class="ModernFormGroup" style="width: 33%;">
            <label class="ModernFormLabel">{{ 'ContractPath' | translate }}</label>
            <input class="ModernFormInput" type="text" [(ngModel)]="ContractualConditions.ContractPath" placeholder="{{'ContractPath' | translate}}">
          </div>
        </div>

        <div class="ModernFormRow" style="margin-top: 16px;">
          <button class="GridCommandButton primary" [disabled]="loadingContractExport" (click)="ExportPartnerContract();">
            <ng-container *ngIf="!loadingContractExport">
              <i class="material-icons">picture_as_pdf</i>
              {{'ExportContract' | translate}}
            </ng-container>
            <mat-spinner *ngIf="loadingContractExport" [diameter]="20"></mat-spinner>
          </button>
        </div>

        <div class="ModernFormDivider"></div>

        <div style="margin-top: 16px;">
          <button class="ModernButton primary" (click)="AddUpdatePartnerContractualConditions();">
            <i class="material-icons">save</i>
            {{'Save' | translate}}
          </button>
        </div>
      </div>

      <!-- Accepted Email Domains Tab -->
      <div *ngIf="ShowAcceptedEmailDomains" class="fullWidth" style="height: auto; float: left; padding: 0;">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">email</i>
          <span>{{'AcceptedEmailDomains' | translate}}</span>
          <i class="material-icons" style="font-size: 16px; margin-left: 8px; color: #4a7bb8;" matTooltip="{{ 'AcceptedEmailDomainsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>info</i>
        </div>

        <div class="ModernFormRow" style="align-items: flex-end;">
          <div class="ModernFormGroup" style="width: 60%;">
            <label class="ModernFormLabel">{{ 'NewEmailDomain' | translate }}</label>
            <input class="ModernFormInput" type="text" [(ngModel)]="NewAcceptedEmailDomain"
                   (ngModelChange)="InvalidAcceptedDomainFormat = false;"
                   placeholder="{{'NewEmailDomainPlaceholder' | translate}}"
                   [style.border-color]="InvalidAcceptedDomainFormat ? '#e74c3c' : ''">
            <span style="font-size: 11px; color: #888; margin-top: 4px;">{{'AcceptedDomainFormatHint' | translate}}</span>
            <span *ngIf="InvalidAcceptedDomainFormat" style="font-size: 12px; color: #e74c3c; margin-top: 4px;">
              {{'InvalidAcceptedDomainFormat' | translate}}
            </span>
          </div>
          <div class="ModernFormGroup" style="width: 20%; padding-bottom: 2px;">
            <button class="ModernButton primary" (click)="AddUpdatePartnerAcceptedDomain();" [disabled]="NewAcceptedEmailDomain == null || NewAcceptedEmailDomain.trim().length == 0">
              <i class="material-icons">add</i>
              {{'Add' | translate}}
            </button>
          </div>
        </div>

        <div class="ModernFormDivider"></div>

        <div *ngIf="AcceptedDomains?.length == 0" style="padding: 16px; text-align: center; color: #999;">
          {{'NoAcceptedEmailDomains' | translate}}
        </div>

        <div *ngIf="AcceptedDomains?.length > 0" style="margin-top: 12px;">
          <table class="ModernTable" style="width: 100%;">
            <thead>
              <tr>
                <th style="text-align: left; padding: 8px 12px;">{{'EmailDomain' | translate}}</th>
                <th style="text-align: left; padding: 8px 12px;">{{'RegisterDate' | translate}}</th>
                <th style="text-align: center; padding: 8px 12px; width: 80px;">{{'Actions' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let domain of AcceptedDomains">
                <td style="padding: 8px 12px;">{{domain.EmailDomain}}</td>
                <td style="padding: 8px 12px;">{{domain.EventRegisterUI}}</td>
                <td style="text-align: center; padding: 8px 12px;">
                  <button class="GridCommandButton" style="color: #e74c3c;" (click)="PrepareAcceptedDomainDelete(domain);" matTooltip="{{ 'Delete' | translate }}">
                    <i class="material-icons">delete</i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Delete Confirmation -->
        <div *ngIf="ShowDeleteAcceptedDomainQuestion" class="ModernConfirmation" style="margin-top: 16px; padding: 16px; background: #fff3cd; border: 1px solid #ffc107; border-radius: 8px;">
          <span>{{'ConfirmDeleteAcceptedDomain' | translate}}: <strong>{{DeletingAcceptedDomain?.EmailDomain}}</strong></span>
          <div style="margin-top: 12px;">
            <button class="ModernButton primary" style="margin-right: 8px;" (click)="DeletePartnerAcceptedDomain(DeletingAcceptedDomain);">
              <i class="material-icons">check</i>
              {{'Confirm' | translate}}
            </button>
            <button class="ModernButton outline" (click)="ShowDeleteAcceptedDomainQuestion = false;">
              <i class="material-icons">close</i>
              {{'Cancel' | translate}}
            </button>
          </div>
        </div>
      </div>

      </div>

      <div class="ModernPopupFooter" *ngIf="ShowBillingInfo">
        <button class="ModernButton outline" (click)="ShowAddNewPartnerForm = false;">
          {{ 'Cancel' | translate }}
        </button>
        <button class="ModernButton success" *ngIf="this.Partner.ID == null;" (click)="AddNewPartner(this.Partner);">
          <i class="material-icons">add</i>
          {{'AddNewPartner' | translate}}
        </button>
        <button class="ModernButton primary" *ngIf="this.Partner.ID?.length > 0;" (click)="UpdatePartner(this.Partner);">
          <i class="material-icons">save</i>
          {{'ModifyPartner' | translate}}
        </button>
      </div>
    </div>
  </div>

  <!-- ========================================
       REDESIGNED PARTNERS PAGE - Modern Layout
       ======================================== -->
  <div class="PartnersMainContent">
    <!-- Page Header -->
    <div class="PartnersPageHeader">
      <div class="PartnersPageTitle">
        <i class="material-icons">manage_accounts</i>
        {{'PartnersMenu' | translate}}
      </div>
      <div class="PartnersPageTitle PartnersPageTitleRight" *ngIf="selectedPartnersTab === 1">
        {{this.Partners?.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'PartnersMenu' | translate}}
      </div>
      <div class="PartnersPageSubtitle">
        {{'ManageYourBusinessPartners' | translate}}
      </div>
    </div>

    <!-- Tab Navigation -->
    <div class="GridModeTabsWrapper">
      <div class="GridModeTab"
           [ngClass]="{'SelectedGridModeTab': selectedPartnersTab === 1}"
           (click)="onSelectPartnersTab(1)">
        <i class="material-icons">people</i>
        <span>{{'PartnersManagement' | translate}}</span>
      </div>
      <div class="GridModeTab"
           [ngClass]="{'SelectedGridModeTab': selectedPartnersTab === 2}"
           (click)="onSelectPartnersTab(2)">
        <i class="material-icons">block</i>
        <span>{{'BlockedPartners' | translate}}</span>
      </div>
    </div>

    <!-- Tab 1: Partners Management -->
    <div *ngIf="selectedPartnersTab === 1">

    <!-- Search Bar -->
    <div class="PartnerSearchContainer">
      <div class="PartnerSearchBar">
        <i class="material-icons search-icon">search</i>
        <input type="text"
               class="PartnerSearchInput"
               placeholder="{{'SearchPartners' | translate}}"
               autocomplete="off"
               [(ngModel)]="this.Filter.SearchTerm"
               (ngModelChange)="this.searchTermUpdate.next($event)">
        <i class="material-icons clear-icon"
           *ngIf="this.Filter.SearchTerm?.length > 0"
           (click)="this.Filter.SearchTerm = ''; this.Partners.length = 0;">close</i>
      </div>
    </div>

    <!-- Command Buttons -->
    <div class="GridCommandCenter">
      <button class="GridCommandButton primary" (click)="InitializeNewPartner();">
        <i class="material-icons">add</i>
        {{ 'Partners.AddNewPartner' | translate }}
      </button>

      <button class="GridCommandButton" (click)="ShowFilter = !ShowFilter;">
        <i class="material-icons">filter_alt</i>
        {{'Filter' | translate}}
        <span class="ButtonNotification" *ngIf="activeFilters.length > 0;">{{activeFilters.length}}</span>
      </button>

      <button class="GridCommandButton" (click)="ShowGeneratePartnersSearchResultsQuestion();">
        <i class="material-icons">file_download</i>
        {{ 'GeneratePartnersSearchResults' | translate }}
      </button>

      <button class="GridCommandButton" (click)="OpenMassEmailPopup();">
        <i class="material-icons">email</i>
        {{ 'CreateMASS' | translate }}
      </button>
    </div>

    <!-- Filter Bar -->
    <div class="FilterBar animated fadeIn">
      <!-- Company Filter Dropdown -->
      <div class="FilterDropdownContainer">
        <div class="ModernDropdownOverlay" *ngIf="showFilterCompanyDropdown" (click)="showFilterCompanyDropdown = false;"></div>
        <div class="FilterDropdownBar" [class.open]="showFilterCompanyDropdown" (click)="showFilterCompanyDropdown = !showFilterCompanyDropdown">
          <span class="dropdown-label">{{'Company' | translate}}:</span>
          <span class="dropdown-value">{{ Filter.Company?.Name || ('All' | translate) }}</span>
          <i class="material-icons dropdown-arrow">expand_more</i>
        </div>
        <div class="FilterDropdownResults" *ngIf="showFilterCompanyDropdown">
          <div class="FilterDropdownOption" *ngFor="let c of this.Companies;"
               [class.selected]="Filter.Company?.ID === c.ID"
               (click)="Filter.Company = c; AddActiveFilter(c.Name, 'Company'); showFilterCompanyDropdown = false;">
            {{c.Name}}
          </div>
        </div>
      </div>

      <!-- Country Filter Dropdown -->
      <div class="FilterDropdownContainer">
        <div class="ModernDropdownOverlay" *ngIf="showFilterCountryDropdown" (click)="showFilterCountryDropdown = false;"></div>
        <div class="FilterDropdownBar" [class.open]="showFilterCountryDropdown" (click)="showFilterCountryDropdown = !showFilterCountryDropdown">
          <span class="dropdown-label">{{'Countries' | translate}}:</span>
          <span class="dropdown-value">{{ Filter.Country?.Name || ('All' | translate) }}</span>
          <i class="material-icons dropdown-arrow">expand_more</i>
        </div>
        <div class="FilterDropdownResults" *ngIf="showFilterCountryDropdown">
          <div class="FilterDropdownOption" *ngFor="let c of this.Countries;"
               [class.selected]="Filter.Country?.ID === c.ID"
               (click)="Filter.Country = c; AddActiveFilter(c.Name, 'Country'); showFilterCountryDropdown = false;">
            {{c.Name}}
          </div>
        </div>
      </div>

      <!-- Account Type Filter Dropdown -->
      <div class="FilterDropdownContainer">
        <div class="ModernDropdownOverlay" *ngIf="showFilterAccountTypeDropdown" (click)="showFilterAccountTypeDropdown = false;"></div>
        <div class="FilterDropdownBar" [class.open]="showFilterAccountTypeDropdown" (click)="showFilterAccountTypeDropdown = !showFilterAccountTypeDropdown">
          <span class="dropdown-label">{{'AccountType' | translate}}:</span>
          <span class="dropdown-value">{{ Filter.AccountType?.Name || ('All' | translate) }}</span>
          <i class="material-icons dropdown-arrow">expand_more</i>
        </div>
        <div class="FilterDropdownResults" *ngIf="showFilterAccountTypeDropdown">
          <div class="FilterDropdownOption"
               [class.selected]="!Filter.AccountType"
               (click)="ClearAccountTypeFilter();">
            {{'All' | translate}}
          </div>
          <div class="FilterDropdownOption" *ngFor="let at of PartnerAccountTypes"
               [class.selected]="Filter.AccountType?.ID === at.ID"
               (click)="Filter.AccountType = at; AddActiveFilter(at.Name, 'AccountType'); showFilterAccountTypeDropdown = false;">
            {{at.Name}}
          </div>
        </div>
      </div>

      <button class="GridCommandButton success" (click)="ShowFilter = false; GetPartnersFiltered();">
        <i class="material-icons">check</i>
        <span>{{'ApplyFilter' | translate}}</span>
      </button>

      <button class="GridCommandButton" (click)="ShowFilter = false;">
        <i class="material-icons">close</i>
      </button>

      <!-- Active Filters -->
      <div class="ActiveFiltersContainer" *ngIf="activeFilters.length > 0">
        <div class="ActiveFilterChip" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
          {{a.Name}}
          <i class="material-icons">close</i>
        </div>
      </div>
    </div>

    <!-- Pagination Bar -->
    <div class="PaginationBar">
      <div class="PaginationControls">
        <div class="PaginationButton"
             [class.disabled]="this.Filter.Pager.PageIndex == 1"
             (click)="this.Filter.Pager.PageIndex > 1 && (this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex - 1) && GetPartnersFiltered();">
          <i class="material-icons">chevron_left</i>
        </div>

        <input type="text"
               class="PageSizeInput"
               [(ngModel)]="Filter.Pager.PageSize"
               (change)="this.Filter.Pager.PageIndex = 1; GetPartnersFiltered();"
               matTooltip="{{ 'PageSize' | translate }}">

        <div class="PaginationButton"
             [class.disabled]="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages"
             (click)="this.Filter.Pager.PageIndex < this.Filter.Pager.Pages && (this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex + 1) && GetPartnersFiltered();">
          <i class="material-icons">chevron_right</i>
        </div>
      </div>

      <div class="PaginationInfo">
        {{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} / {{this.Filter.Pager.Pages}}
      </div>
    </div>

    <!-- Compact Grid Table -->
    <div class="CompactGrid">
      <!-- Grid Header -->
      <div class="CompactGridHeader">
        <div class="CompactGridCell col-index">#</div>
        <div class="CompactGridCell col-name">{{'Name' | translate}}</div>
        <div class="CompactGridCell col-code">{{'Code' | translate}}</div>
        <div class="CompactGridCell col-vat">{{'VAT' | translate}}</div>
        <div class="CompactGridCell col-country">{{'Country' | translate}}</div>
        <div class="CompactGridCell col-city">{{'Partners.PartnerWindow.City' | translate}}</div>
        <div class="CompactGridCell col-registered">{{'EventRegister' | translate}}</div>
        <div class="CompactGridCell col-verified">{{'EUViesVerified' | translate}}</div>
        <div class="CompactGridCell col-actions">{{'Actions' | translate}}</div>
      </div>

      <!-- Grid Body -->
      <div class="CompactGridBody">
        <div class="CompactGridRow" *ngFor="let p of this.Partners; let i=index;">
          <div class="CompactGridCell col-index">{{i + 1}}</div>
          <div class="CompactGridCell col-name">{{p.Name}}</div>
          <div class="CompactGridCell col-code">{{p.Code}}</div>
          <div class="CompactGridCell col-vat">{{p.VAT}}</div>
          <div class="CompactGridCell col-country">{{p.BillingAddress?.Country?.Name}}</div>
          <div class="CompactGridCell col-city">{{p.BillingAddress?.City}}</div>
          <div class="CompactGridCell col-registered">{{p.RegisteredUI}}</div>
          <div class="CompactGridCell col-verified">
            <i class="material-icons VerifiedBadge"
               *ngIf="p.EUVATVerified"
               matTooltip="{{ 'EUVATVerifiedDesc' | translate }}"
               matTooltipClass='neutral-tool-tip-management'>verified_user</i>
            <i class="material-icons UnverifiedBadge"
               *ngIf="!p.EUVATVerified">remove_circle_outline</i>
          </div>
          <div class="CompactGridCell col-actions">
            <div class="GridActionButton" [matMenuTriggerFor]="menu">
              <i class="material-icons">more_vert</i>
            </div>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="InitializeNewPartnerForm(p);">
                <i class="material-icons">edit</i>
                <span>{{ 'Receptions.Table.ButtonMenu.modify' | translate }}</span>
              </button>
              <button mat-menu-item (click)="this.Partner = p; this.GetB2BClientOCReadyItemsUX(p);"
                      matTooltip="{{ 'RequestItemsShipmentDescription' | translate}}"
                      matTooltipClass='neutral-tool-tip'>
                <i class="material-icons">local_shipping</i>
                <span>{{ 'RequestItemsShipment' | translate }}</span>
              </button>
              <button mat-menu-item (click)="GeneratePublicLink(p);">
                <i class="material-icons">link</i>
                <span>{{ 'GeneratePublicLink' | translate }}</span>
              </button>
              <button mat-menu-item (click)="GenerateB2BRegistrationLink(p);"
                      *ngIf="parent.User?.UserManagementInfo?.ManagementRights?.CurrentUIPageRights?.UserPageRole?.ID === 3">
                <i class="material-icons">person_add</i>
                <span>{{ 'GenerateB2BRegistrationLink' | translate }}</span>
              </button>
              <button mat-menu-item class="danger-menu-item">
                <i class="material-icons">delete</i>
                <span>{{ 'Delete' | translate }}</span>
              </button>
            </mat-menu>
          </div>
        </div>

        <!-- Empty State -->
        <div class="EmptyState" *ngIf="this.Partners?.length === 0 && !this.parent.loading">
          <i class="material-icons EmptyStateIcon">people_outline</i>
          <div class="EmptyStateTitle">{{'NoPartnersFound' | translate}}</div>
          <div class="EmptyStateText">{{'TryAdjustingFilters' | translate}}</div>
        </div>

        <!-- Loading State -->
        <div class="LoadingContainer" *ngIf="this.parent.loading">
          <mat-spinner [diameter]="40"></mat-spinner>
          <div class="LoadingText">{{'Loading' | translate}}...</div>
        </div>
      </div>
    </div>

    </div>
    <!-- End Tab 1: Partners Management -->

    <!-- Tab 2: Blocked Partners -->
    <div *ngIf="selectedPartnersTab === 2">

    <!-- Search Bar -->
    <div class="PartnerSearchContainer">
      <div class="PartnerSearchBar">
        <i class="material-icons search-icon">search</i>
        <input type="text"
               class="PartnerSearchInput"
               placeholder="{{'SearchBlockedPartners' | translate}}"
               autocomplete="off"
               [(ngModel)]="this.BlockedFilter.SearchTerm"
               (ngModelChange)="this.blockedSearchTermUpdate.next($event)">
        <i class="material-icons clear-icon"
           *ngIf="this.BlockedFilter.SearchTerm?.length > 0"
           (click)="this.BlockedFilter.SearchTerm = ''; this.BlockedPartners = [];">close</i>
      </div>
    </div>

    <!-- Command Buttons -->
    <div class="GridCommandCenter">
      <button class="GridCommandButton" (click)="ShowBlockedFilter = !ShowBlockedFilter;">
        <i class="material-icons">filter_alt</i>
        {{'Filter' | translate}}
        <span class="ButtonNotification" *ngIf="blockedActiveFilters.length > 0;">{{blockedActiveFilters.length}}</span>
      </button>

      <button class="GridCommandButton" (click)="GetBlockedPartnersFiltered();">
        <i class="material-icons">refresh</i>
        {{'ApplyFilter' | translate}}
      </button>
    </div>

    <!-- Filter Bar (Collapsible) -->
    <div class="FilterBar animated fadeIn" *ngIf="ShowBlockedFilter">
      <!-- Company Filter Dropdown -->
      <div class="FilterDropdownContainer">
        <div class="ModernDropdownOverlay" *ngIf="showBlockedFilterCompanyDropdown" (click)="showBlockedFilterCompanyDropdown = false;"></div>
        <div class="FilterDropdownBar" [class.open]="showBlockedFilterCompanyDropdown" (click)="showBlockedFilterCompanyDropdown = !showBlockedFilterCompanyDropdown">
          <span class="dropdown-label">{{'Company' | translate}}:</span>
          <span class="dropdown-value">{{ BlockedFilter.Company?.Name || ('All' | translate) }}</span>
          <i class="material-icons dropdown-arrow">expand_more</i>
        </div>
        <div class="FilterDropdownResults" *ngIf="showBlockedFilterCompanyDropdown">
          <div class="FilterDropdownOption" *ngFor="let c of this.Companies;"
               [class.selected]="BlockedFilter.Company?.ID === c.ID"
               (click)="BlockedFilter.Company = c; AddBlockedActiveFilter(c.Name, 'Company'); showBlockedFilterCompanyDropdown = false;">
            {{c.Name}}
          </div>
        </div>
      </div>

      <!-- Country Filter Dropdown -->
      <div class="FilterDropdownContainer">
        <div class="ModernDropdownOverlay" *ngIf="showBlockedFilterCountryDropdown" (click)="showBlockedFilterCountryDropdown = false;"></div>
        <div class="FilterDropdownBar" [class.open]="showBlockedFilterCountryDropdown" (click)="showBlockedFilterCountryDropdown = !showBlockedFilterCountryDropdown">
          <span class="dropdown-label">{{'Countries' | translate}}:</span>
          <span class="dropdown-value">{{ BlockedFilter.Country?.Name || ('All' | translate) }}</span>
          <i class="material-icons dropdown-arrow">expand_more</i>
        </div>
        <div class="FilterDropdownResults" *ngIf="showBlockedFilterCountryDropdown">
          <div class="FilterDropdownOption" *ngFor="let c of this.Countries;"
               [class.selected]="BlockedFilter.Country?.ID === c.ID"
               (click)="BlockedFilter.Country = c; AddBlockedActiveFilter(c.Name, 'Country'); showBlockedFilterCountryDropdown = false;">
            {{c.Name}}
          </div>
        </div>
      </div>

      <button class="GridCommandButton success" (click)="ShowBlockedFilter = false; GetBlockedPartnersFiltered();">
        <i class="material-icons">check</i>
        <span>{{'ApplyFilter' | translate}}</span>
      </button>

      <button class="GridCommandButton" (click)="ShowBlockedFilter = false;">
        <i class="material-icons">close</i>
      </button>

      <!-- Active Filters -->
      <div class="ActiveFiltersContainer" *ngIf="blockedActiveFilters.length > 0">
        <div class="ActiveFilterChip" *ngFor="let a of this.blockedActiveFilters;" (click)="RemoveBlockedActiveFilter(a.ID, a.Type);">
          {{a.Name}}
          <i class="material-icons">close</i>
        </div>
      </div>
    </div>

    <!-- Pagination Bar -->
    <div class="PaginationBar">
      <div class="PaginationControls">
        <div class="PaginationButton"
             [class.disabled]="this.BlockedFilter.Pager.PageIndex == 1"
             (click)="this.BlockedFilter.Pager.PageIndex > 1 && (this.BlockedFilter.Pager.PageIndex = this.BlockedFilter.Pager.PageIndex - 1) && GetBlockedPartnersFiltered();">
          <i class="material-icons">chevron_left</i>
        </div>

        <input type="text"
               class="PageSizeInput"
               [(ngModel)]="BlockedFilter.Pager.PageSize"
               (change)="this.BlockedFilter.Pager.PageIndex = 1; GetBlockedPartnersFiltered();"
               matTooltip="{{ 'PageSize' | translate }}">

        <div class="PaginationButton"
             [class.disabled]="this.BlockedFilter.Pager.PageIndex == this.BlockedFilter.Pager.Pages"
             (click)="this.BlockedFilter.Pager.PageIndex < this.BlockedFilter.Pager.Pages && (this.BlockedFilter.Pager.PageIndex = this.BlockedFilter.Pager.PageIndex + 1) && GetBlockedPartnersFiltered();">
          <i class="material-icons">chevron_right</i>
        </div>
      </div>

      <div class="PaginationInfo">
        {{'Page' | translate}}: {{this.BlockedFilter.Pager.PageIndex}} / {{this.BlockedFilter.Pager.Pages}}
      </div>
    </div>

    <!-- Compact Grid Table -->
    <div class="CompactGrid BlockedPartnersGrid">
      <!-- Grid Header -->
      <div class="CompactGridHeader">
        <div class="CompactGridCell col-index">#</div>
        <div class="CompactGridCell col-name">{{'Name' | translate}}</div>
        <div class="CompactGridCell col-code">{{'Code' | translate}}</div>
        <div class="CompactGridCell col-vat">{{'VAT' | translate}}</div>
        <div class="CompactGridCell col-country">{{'Country' | translate}}</div>
        <div class="CompactGridCell col-overdue-count">{{'OverdueInvoices' | translate}}</div>
        <div class="CompactGridCell col-overdue-days">{{'DaysOverdue' | translate}}</div>
        <div class="CompactGridCell col-oldest-date">{{'OldestDueDate' | translate}}</div>
        <div class="CompactGridCell col-verified">{{'BlockedStatus' | translate}}</div>
        <div class="CompactGridCell col-actions">{{'Actions' | translate}}</div>
      </div>

      <!-- Grid Body -->
      <div class="CompactGridBody">
        <div class="CompactGridRow" *ngFor="let p of this.BlockedPartners; let i=index;">
          <div class="CompactGridCell col-index">{{i + 1}}</div>
          <div class="CompactGridCell col-name">{{p.Name}}</div>
          <div class="CompactGridCell col-code">{{p.Code}}</div>
          <div class="CompactGridCell col-vat">{{p.VAT}}</div>
          <div class="CompactGridCell col-country">{{p.BillingAddress?.Country?.Name}}</div>
          <div class="CompactGridCell col-overdue-count">
            <span class="OverdueCountBadge">{{p.BlockedStatistics?.OverdueInvoicesCount}}</span>
          </div>
          <div class="CompactGridCell col-overdue-days">
            <span class="OverdueDaysBadge" [class.critical]="p.BlockedStatistics?.OldestOverdueDays > 60" [class.warning]="p.BlockedStatistics?.OldestOverdueDays <= 60 && p.BlockedStatistics?.OldestOverdueDays > 30">
              {{p.BlockedStatistics?.OldestOverdueDays}} {{'Days' | translate}}
            </span>
          </div>
          <div class="CompactGridCell col-oldest-date">{{p.BlockedStatistics?.OldestPaymentDueDateUI}}</div>
          <div class="CompactGridCell col-verified">
            <i class="material-icons BlockedBadge"
               matTooltip="{{ 'PartnerBlockedTooltip' | translate }}: {{p.BlockedStatistics?.OldestOverdueDays}} {{'DaysOverdue' | translate}} ({{ 'Tolerance' | translate }}: {{p.BlockedStatistics?.UnpaidToleranceDays}} {{'Days' | translate}})"
               matTooltipClass='neutral-tool-tip-management'>block</i>
          </div>
          <div class="CompactGridCell col-actions">
            <button class="ViewOverdueBtn" (click)="ViewOverdueInvoices(p);">
              <i class="material-icons">receipt_long</i>
            </button>
          </div>
        </div>

        <!-- Empty State -->
        <div class="EmptyState" *ngIf="this.BlockedPartners?.length === 0 && !this.parent.loading">
          <i class="material-icons EmptyStateIcon">check_circle</i>
          <div class="EmptyStateTitle">{{'NoBlockedPartnersFound' | translate}}</div>
          <div class="EmptyStateText">{{'NoBlockedPartnersDescription' | translate}}</div>
        </div>

        <!-- Loading State -->
        <div class="LoadingContainer" *ngIf="this.parent.loading">
          <mat-spinner [diameter]="40"></mat-spinner>
          <div class="LoadingText">{{'Loading' | translate}}...</div>
        </div>
      </div>
    </div>

    </div>
    <!-- End Tab 2: Blocked Partners -->

  </div>

  <!-- Overdue Invoices Modal - ModernPopup Large -->
  <div class="ModernPopupOverlay" *ngIf="this.showOverdueInvoicesModal" (click)="CloseOverdueInvoicesModal();">
    <div class="ModernPopup large" (click)="$event.stopPropagation();">
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons">receipt_long</i>
          <span>{{'OverdueInvoicesFor' | translate}} {{this.currentOverduePartner?.Name}}</span>
        </div>
        <button class="ModernPopupClose" (click)="CloseOverdueInvoicesModal();">
          <i class="material-icons">close</i>
        </button>
      </div>

      <div class="ModernPopupBody">
        <!-- Loading -->
        <div class="OverdueInvoicesLoading" *ngIf="this.loadingOverdueInvoices">
          <mat-spinner diameter="32"></mat-spinner>
        </div>

        <!-- No Results -->
        <div class="OverdueInvoicesEmpty" *ngIf="!this.loadingOverdueInvoices && this.OverdueInvoices?.length === 0">
          <i class="material-icons">check_circle_outline</i>
          <span>{{'NoOverdueInvoicesFound' | translate}}</span>
        </div>

        <!-- Invoice List -->
        <div class="OverdueInvoicesList" *ngIf="!this.loadingOverdueInvoices && this.OverdueInvoices?.length > 0">
          <div class="OverdueInvoiceCard" *ngFor="let inv of this.OverdueInvoices; let i = index;">
            <div class="OverdueInvoiceRow">
              <div class="OverdueInvoiceIndex">
                <span>{{i + 1}}</span>
              </div>
              <div class="OverdueInvoiceField">
                <span class="OverdueInvoiceLabel">{{'InvoiceNumber' | translate}}</span>
                <span class="OverdueInvoiceValue OverdueInvoiceNumber">{{inv.AccountingNumber?.DisplayValue}}</span>
              </div>
              <div class="OverdueInvoiceField">
                <span class="OverdueInvoiceLabel">{{'Date' | translate}}</span>
                <span class="OverdueInvoiceValue">{{inv.EventRegisterUIDate}}</span>
              </div>
              <div class="OverdueInvoiceField">
                <span class="OverdueInvoiceLabel">{{'DueDate' | translate}}</span>
                <span class="OverdueInvoiceValue OverdueInvoiceDueDate">{{inv.PaymentDueDateUI}}</span>
              </div>
              <div class="OverdueInvoiceField">
                <span class="OverdueInvoiceLabel">{{'Total' | translate}}</span>
                <span class="OverdueInvoiceValue">{{inv.Total?.UITotalQtyPriceVAT?.Integer}}{{inv.Total?.UITotalQtyPriceVAT?.Decimals}} {{inv.Currency?.Name}}</span>
              </div>
            </div>
            <div class="OverdueInvoiceStatusRow">
              <span class="OverdueInvoiceStatusBadge Overdue">{{inv.DocumentStatus?.Name}}</span>
              <span class="OverdueInvoiceDaysLate" *ngIf="GetDaysLate(inv.PaymentDueDate) > 0">{{GetDaysLate(inv.PaymentDueDate)}} {{'DaysLate' | translate}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="ModernPopupFooter">
        <button class="ModernPopupCloseBtn" (click)="CloseOverdueInvoicesModal();">
          <span>{{'Close' | translate}}</span>
        </button>
      </div>
    </div>
  </div>

  </div>